import React, { useEffect, useState, useRef, useContext, } from "react";
import axios from "axios";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import green_tick from "../assets/images/green_tick.png";
import yellow_error from "../assets/images/yellow_error.png";
import whatsapp_logo from "../assets/images/whatsapp-96.png";
import loading_fountain from "../assets/images/Fountain.gif";
import truck_delivery from "../assets/images/delivery-truck.png";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_DOMAIN, country_codes, eventStatusMap, string_sanitizing_regex, wati_DOMAIN } from "../components/constants";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ImportExport from "@mui/icons-material/ImportExport";
import { LicenseInfo } from "@mui/x-license-pro";
import SearchIcon from "@mui/icons-material/Search";
import dayjs from "dayjs";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SellIcon from "@mui/icons-material/Sell";
import useSnackbar from "../components/Snackbar/UseSnackbar";
import SettingsModal from "../components/SettingsModal/SettingsModal";
import { AuthContext } from "../components/contexts/AuthContext";
import { Select, InputNumber, Button, Dropdown, Timeline, Modal as AntdModal, Input as AntdInput, Space, DatePicker, Image, Upload, Collapse, Checkbox as AntdCheckbox, Table, Tooltip, Divider, Tabs, Badge, ConfigProvider, Spin, Popover, Typography, Row, Radio, Flex } from 'antd';
import { BellOutlined, CalendarOutlined, CheckCircleOutlined, ClockCircleOutlined, DeleteOutlined, DollarOutlined, DownloadOutlined, EditOutlined, FileExcelOutlined, FilePdfOutlined, FilterOutlined, HistoryOutlined, HomeFilled, MailOutlined, MinusCircleTwoTone, NumberOutlined, PlusCircleOutlined, PlusCircleTwoTone, PlusOutlined, PlusSquareOutlined, RetweetOutlined, RobotOutlined, SaveOutlined, SearchOutlined, SendOutlined, SettingOutlined, TruckFilled, UserOutlined } from '@ant-design/icons';
import wati_logo_only from '../assets/wati_logo_only.png'
import uzdLogo from '../assets/images/uzd_logo_small.jpeg'
import WatiTemplatesModal from '../components/Queryset/WatiWidgets/wati_templates_modal'
import { generateExcel, generatePDF, getCountryCode, openNewTab, playChime, scrollToExtreme, showNotification } from "../components/misc_functions";
import CustomerAddModal from "../components/CustomerAdd/CustomerAddModal";
import WatiFinalViewModal from '../components/Queryset/WatiWidgets/wati_last_view'
import AddressManagementModal from "../components/Queryset/AdressManagement/AddressManagement";
import AddEditAddresses from "../components/Queryset/AdressManagement/AddEditAddresses";
import PayByLinkModal from "../components/Queryset/PayByLink/PayByLinkModal";
import SendRemindertoWati from "../components/Queryset/WatiWidgets/SendRemindertoWati";
import QueryChatMini from "../components/Queryset/QueryChatMini";
import { useSocketEvents } from "../components/useSocketEvents";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
const { RangePicker } = DatePicker;
const wati_msg_approval_incoming_sound = new URL("../assets/sounds/wati_msg_approval_incoming.mp3", import.meta.url).href;
const wati_msg_approved_notif_sound = new URL("../assets/sounds/success-notification.mp3", import.meta.url).href;
const queryset_added_notif_sound = new URL("../assets/sounds/long_pop.mp3", import.meta.url).href;
const queryset_updated_notif_sound = new URL("../assets/sounds/blip.mp3", import.meta.url).href;
const queryset_deleted_notif_sound = new URL("../assets/sounds/positive.mp3", import.meta.url).href;
LicenseInfo.setLicenseKey(
  "e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y"
);

pdfMake.vfs = pdfFonts.pdfMake.vfs;

var supplierIdToName = [];

// Displaying the Users to the admin and their information
function Queryset() {

  //capitalize first letter of every word and lower case everything else
  function capitalizeWords(inputString) {
    if (typeof inputString !== "string") {
      throw new Error("Input must be a string, you nitwit!");
    }

    return inputString
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }
  const head = {
    headers: {
      accessToken: localStorage.getItem("accessToken")
    }
  };
  const { authState } = useContext(AuthContext);

  const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();

  // The basic datasets
  const [querySet, setquerySet] = useState([]);
  const [postponedQuerySet, setPostponedQuerySet] = useState([]);
  const [querySetTable, setquerySetTable] = useState([]);
  const [usersSet, setUsersSet] = useState([]);
  const [makeSet, setmakeSet] = useState([]);
  const [brandSet, setbrandSet] = useState([]);
  const [modelSet, setModelSet] = useState([]);
  const [supplierSet, setsupplierSet] = useState([]);
  const [regionDataSet, setRegionDataSet] = useState([]);
  const [cus_name_set_for_select, set_cus_name_set_for_select] = useState([]);
  const [queryStatusSet, setQueryStatusSet] = useState([]);
  const [costPriceSet, setCostPriceSet] = useState([]);
  const [priceHistory, setPriceHistory] = useState([]);
  const [remarksSet, setRemarksSet] = useState([]);
  const [queryOriginSet, setqueryOriginSet] = useState([]);
  const [miscTemplates, setMiscTemplates] = useState([]);
  const [partsDataSet, setPartsDataSet] = useState([]);
  const [supplierScoreDataset, setsupplierScoreDataset] = useState([{ value: 5, label: "5⭐" }, { value: 4, label: "4⭐" }, { value: 3, label: "3⭐" }, { value: 2, label: "2⭐" }, { value: 1, label: "1⭐" }]);
  const [supplierNumbersSet, setSupplierNumbersSet] = useState([]);



  const [loading, setLoading] = useState(true);
  const [carLogoTypes, setCarLogoTypes] = useState([]);
  const [add_query_btn_loading, setAdd_query_btn_loading] = useState(false);
  const [add_query_btn_disabled, setAdd_query_btn_disabled] = useState(false);
  const [bot_status, setBot_status] = useState("Loading Bot status...");


  //Search parameters
  const [searchUser, setSearchUser] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());

  //Custom modal to add stuff
  const [queryModalHeading, setQueryModalHeading] = useState("Create New Query");
  const [modalHeading, setModalHeading] = useState("");
  const [modal_data, set_modal_data] = useState(null);
  const [adding_modal_loading, set_adding_modal_loading] = useState(false);
  const [cus_name_loading, set_cus_name_loading] = useState(true);
  const [loading_models, set_loading_models] = useState(false);

  //items for tab view data
  const [currentTabState, setCurrentTabState] = useState("All");



  //file upload misc states
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  //form data
  const [make_data, set_make_data] = useState([]);
  const [brand_data, set_brand_data] = useState(null);
  const [model_data, set_model_data] = useState(null);
  const [queryidEdit, set_queryid] = useState(null);
  const [model_details_data, set_model_details_data] = useState(null);
  const [year_data, set_year_data] = useState(null);
  const [chassisno_data, set_chassisno_data] = useState(null);
  const [cylinder_data, set_cylinder_data] = useState(null);
  const [bodypart_data, set_bodypart_data] = useState(null);
  const [supplier_score, set_supplier_score] = useState({ value: 5, label: "5⭐" });
  const [phone_data, set_phone_data] = useState(null);
  const [region_data, set_region_data] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [WhatsappStatus, setWhatsappStatus] = useState([]);
  const [edit, setEdit] = useState(false);
  const [suppCount, setSuppCount] = useState(0);
  const [queryOrigin, setQueryOrigin] = useState(null);
  const [followupMsg, setFollowupMsg] = useState(true);
  const [sendQidToWati, setSendQidToWati] = useState(true);


  const [loadApiSuppCount, setLoadApiSuppCount] = useState(false);

  const [defaultActiveKey, setDefaultActiveKey] = useState(1);



  //misc data
  const [isDownloadButtonDisabled, setIsDownloadButtonDisabled] = useState(false);

  //references
  const file_DataRef = useRef(null);
  const queryDateRef = useRef(null);

  //Tab Focus to know if to send desktop notifications
  const [isTabFocused, setIsTabFocused] = useState(
    document.visibilityState === "visible"
  );
  const isTabFocusedRef = useRef(isTabFocused);

  const [expandedRows, setExpandedRows] = useState({});

  const handleExpandClick = (rowIndex) => {
    setExpandedRows((prev) => ({
      ...prev,
      [rowIndex]: !prev[rowIndex],
    }));
  };

  // These are for the Modals
  //Query adding modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setSendQidToWati(true);
    setIsQsDisabled(false);
    setSuppCount(0);
    if (WhatsappStatus.status === "logged_in") {
      reload_customers();
      setOpen(true);
    } else AntdModal.warning({ title: 'WhatsApp Bot Issue', content: 'Please resolve WhatsApp Bot issues before making a query.' });
  };
  const handleClose = () => {
    setQueryModalHeading("Create New Query");
    setPriceHistory(null);
    //this will reload all the queries
    reloadQuerySet();
    // document.getElementById("sup_count").style.display = "none";
    set_make_data(null);
    setModelSet(null);
    set_brand_data(null);
    set_year_data(null);
    set_model_data(null);
    set_model_details_data(null);
    set_chassisno_data(null);
    set_cylinder_data(null);
    set_bodypart_data(null);
    set_phone_data(null);
    set_region_data(null);
    setFileList([]);
    setQueryOrigin(null);
    setEdit(false);
    setSuppCount(0);
    setIsQsDisabled(false);
    setEdit(false)
    set_queryid(null)
    setTimeout(() => {
      if (file_DataRef.current) {
        file_DataRef.current.disabled = true;
      }
    }, 0);
    setOpen(false);
  };

  //This one calls the API and sends the message directly to WATI. No other checkings and scheduling.
  const send_wati_general_message = async (phone, message) => {
    try {
      var response = await axios.post(API_DOMAIN + "/whatsapp/send_wati_general_message", { phone: phone, message: message, user: authState.id });
      if (response?.data?.success) {
        if (response?.data?.data?.sent)
          SuccessSnackbar("Message sent successfully!");
        if (response?.data?.data?.wait_approval)
          InfoSnackbar("Message Waiting for approval!");
        return true;
      } else {
        return false;
      }
    } catch (error) {
      ErrorSnackbar("Failed to send message! Try again later\n", error.message);
    }
  };

  //this function calls the API that will check if the template needs approval not and does the process accordingly.
  const process_and_schedule_wati_general_message = async (phone, message, replyMessageId, query_id, moredetails) => {
    try {
      var response = await axios.post(API_DOMAIN + "/whatsapp/process_and_schedule_wati_general_message", { phone: phone, message: message, user: authState.id, replyMessageId, query_id, moredetails }, head);
      if (response?.data?.success) {
        if (response?.data?.data?.sent)
          SuccessSnackbar("Message sent successfully!");
        if (response?.data?.data?.wait_approval)
          InfoSnackbar("Message Waiting for approval!");
        return true;
      } else {
        return false;
      }
    } catch (error) {
      ErrorSnackbar("Failed to send message! Try again later" + error.message);
    }
  };

  const send_wati_approved_message = async (data, message) => {
    try {
      var response = await axios.post(API_DOMAIN + "/whatsapp/send_approved_wati_message", { id: data?.id, phone: data?.phone, admin: authState.id, operator_id: data?.user, replyMessageId: data?.replyMessageId, msg_text: message, moredetails: data?.moredetails }, head);
      if (response?.data?.success) {
        SuccessSnackbar("Message sent successfully!");
        set_wati_msgs_waiting_approval(response?.data?.data);
        return true;
      } else {
        ErrorSnackbar("Failed to approve message");
        return false;
      }
    } catch (error) {
      ErrorSnackbar("Failed to send message! Try again later\n" + error.message);
    }
  };

  const [load_send_link_to_wati, setLoad_send_link_to_wati] = useState(false);
  const handleSendWatiLink = async () => {
    try {
      var message = [];

      const phone = openLinkGen?.data?.phone;

      message.push(`Dear ${openLinkGen?.data?.customer_info?.name}, \nPlease find the link-to-pay link generated below, to proceed with the payment.${enable_tabby ? "\n\nFor your convenience Tabby is enabled." : ""}\n\n${theLink}\n\nDont Forget to share the screenshot.\n\nThank you for choosing UZDpart!`);
      setLoad_send_link_to_wati(true);
      var response = await send_wati_general_message(phone, message);

      if (response) {
        document.getElementById("link_gen_send_wati").style.display = "none";
        setOpenLinkGen({ open: false, data: null });
        setTheLink(null);
      } else {
        ErrorSnackbar("Failed to send message! Try again later.");
      }
    } catch (error) {
      ErrorSnackbar("Failed to send message! Try again later\n" + error.message);
    }
    finally {
      setLoad_send_link_to_wati(false);
    }
  };

  //Link generation model
  // const [dataLink, setDataLink] = useState({});
  const [openLinkGen, setOpenLinkGen] = useState({ open: false, data: null });
  const handleOpenLinkGen = (data) => {
    // setDataLink(data);
    setLinkDescription(`${data.body_part.length > 70 ? "Multiple Parts" : data.body_part}`);
    setLinkTitle(`${data.make}-${data.model}`);
    setLinkAmount(priceValues?.[data?.query_id]?.price_given);

    if (data.status != "Confirmed") {
      AntdModal.confirm({
        title: 'Query Not Confirmed',
        content: 'This query is not yet set to "Confirmed". Do you want to proceed? This will change the status to "Confirmed & Paid" automatically.',
        okText: 'Proceed',
        cancelText: 'Cancel',
        onOk: () => setOpenLinkGen({ open: true, data: data }),
      });
    } else {
      setOpenLinkGen({ open: true, data: data });
    }
  };
  const handleCloseLinkGen = () => {
    document.getElementById("link_gen_send_wati").style.display = "none";
    setOpenLinkGen({ open: false, data: null });
    // setDataLink({});
    setTheLink(null);
    set_enable_tabby(false);
  };

  const [pay_by_link_loading, setPay_by_link_loading] = useState(false);


  const handleLinkGen = async () => {
    if (!linkTitle) {
      WarningSnackbar("Please enter a valid Title");
      return;
    }
    if (!linkAmount) {
      WarningSnackbar("Please enter a valid Amount");
      return;
    }
    try {
      setPay_by_link_loading(true);
      var response = await axios.post(API_DOMAIN + "/whatsapp/get_payByLink_link", { query_id: openLinkGen.data.query_id, title: linkTitle, description: linkDescription, amount: (linkAmount * (1 + linkVATPercent / 100)).toFixed(2), processing_fee: linkFeePercent, enable_tabby }, head);
      if (response.data.success) {
        setTheLink(response.data.data.payment_url);

        setOpenLinkGen(prev => ({
          ...prev,
          data: {
            ...prev.data,
            moredetails: {
              ...prev.data.moredetails,
              payment_details: response.data.data,
            }
          }
        }))

        SuccessSnackbar("Mamo-Pay Link Generated Successfully!");
        document.getElementById("link_gen_send_wati").style.display = "flex";

        // await axios.post(API_DOMAIN + "/whatsapp/update_querysetV2", dataLink);
      }
    } catch (error) {
      ErrorSnackbar(
        "Failed to generate Mamo-Pay Link! Try again later\n" + error.message
      );
    }
    finally {
      setPay_by_link_loading(false);
    }
  };

  const [linkTitle, setLinkTitle] = useState("");
  const [linkDescription, setLinkDescription] = useState("");
  const [linkAmount, setLinkAmount] = useState("");
  const [isQsDisabled, setIsQsDisabled] = useState(false);
  const [linkFeePercent, setLinkFeePercent] = useState(2);
  const [disablePercentEdit, setDisablePercentEdit] = useState(false);
  const [enable_tabby, set_enable_tabby] = useState(false);
  const [linkVATPercent, setLinkVATPercent] = useState(5);



  const handle_tabby_enable_change = (e) => {
    set_enable_tabby(e.target.checked);
    if (e.target.checked) {
      setLinkFeePercent(5);
      setDisablePercentEdit(true);
    }
    else {
      setDisablePercentEdit(false);
      setLinkFeePercent(2);
    }
  }

  const setLinkTitleHandler = (title) => {
    if (linkTitle.length <= 50) {
      if (string_sanitizing_regex.test(title)) {
        setLinkTitle(title);
        return;
      }
    }
    InfoSnackbar("Title can't be more than 50 characters and can't contain special characters, you can use hyphens, commas and periods only!");
  };

  const setLinkDescriptionHandler = (title) => {
    if (linkDescription.length <= 100) {
      if (string_sanitizing_regex.test(title)) {
        setLinkDescription(title);
        return;
      }
    }
    InfoSnackbar("Description can't be more than 100 characters and can't contain special characters, you can use hyphens, commas and periods only!");
  };

  const [theLink, setTheLink] = useState(null);

  //Adding stuff to DB modal
  const [open_add_modal, setAddModalState] = useState(false);
  const handleOpenAddModal = (title) => {
    if (title == "Add New Model" && !brand_data) {
      WarningSnackbar("Please select a 'Make' first, to add a new model");
    }
    else {
      setModalHeading(
        title == "Add New Model" ? "Add New '" + brandSet.find((e) => e.value == brand_data).label + "' Model" : title
      );
      set_modal_data("");
      setAddModalState(true);
    }
  };
  const handleCloseAddModal = () => {
    set_modal_data("");
    setModalHeading("");
    setAddModalState(false);
  };

  //Settings modal states
  const [open_settings, setSettings] = useState(false);
  const handleOpenSettingsModal = () => {
    setSettings(true);
  };
  const handleCloseSettingsModal = () => {
    setSettings(false);
  };

  const [approval_message_view, setApproval_message_view] = useState(false);
  const [loadingBtns, setLoadingBtns] = useState({});
  const [loadingDeleteBtns, setLoadingDeleteBtns] = useState({});
  const pre_wati_approval_msg_handler = async (data) => {

    setLoadingBtns(prev => ({ ...prev, [data?.id]: true }));
    setApproval_message_view(true);

    var temp_priceValues = {
      best_price_received: data?.queryset.best_price_received || 0,
      price_percentage: (
        ((data?.queryset?.price_given -
          data?.queryset?.best_price_received -
          data?.queryset?.delivery_cost ?? 0) /
          data?.queryset?.best_price_received) *
        100
      ).toFixed(2) === "NaN"
        ? 0
        : (
          ((data?.queryset?.price_given -
            data?.queryset?.best_price_received -
            data?.queryset?.delivery_cost ?? 0) /
            data?.queryset?.best_price_received) *
          100
        ).toFixed(2),
      price_given: data?.queryset.price_given || 0,
      status: data?.queryset.status,
      delivery_cost: data?.queryset.delivery_cost
        ? { DeliveryCost: data?.queryset.delivery_cost }
        : { DeliveryCost: 0, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0 },
      statusValue:
        data?.queryset.status == "postponed"
          ? new Date(data?.queryset?.moredetails?.statusValue)
          : data?.queryset?.moredetails?.statusValue || null,
      remarks: data?.queryset?.moredetails?.remarks || "",
      f_date: dayjs(data?.queryset?.moredetails?.f_date) || null,
      warranty: data?.queryset?.moredetails?.warranty || 0,
    };


    setPriceValues(prev => ({
      ...prev,
      [data?.id]: {
        ...temp_priceValues
      }
    }));

    const templates = await loadAllTemplates();
    data.queryset.user_name = data?.user_name;
    setAllTemplateData({
      approval_id: data?.id,
      msg_text: data?.msg_text,
      moredetails: data?.moredetails,
      record: data?.queryset,
      templates: templates,
      templates_temp: templates,
      chosenTemplateID: data?.replyMessageId,
      finalViewOpen: true,
    })
    setLoadingBtns(prev => ({ ...prev, [data?.id]: false }));
  }

  //handling onclicks
  const handling_setquerySet = (data) => {
    const { datasetMap, initialPriceValues } = data.reduce(
      (acc, dataset, index) => {
        // Add index as key
        dataset.key = index;

        // Calculate price percentage
        const { price_given, best_price_received, delivery_cost = 0 } = dataset;
        const numerator = price_given - best_price_received - delivery_cost;
        const percentage = (numerator / best_price_received) * 100;
        dataset.price_percentage = isNaN(percentage) ? 0 : percentage.toFixed(2);

        // Destructure nested properties with defaults
        const { status, moredetails = {} } = dataset;

        // Build dataset maps
        acc.datasetMap[dataset.query_id] = dataset;
        acc.initialPriceValues[dataset.query_id] = {
          supplier: dataset.supplier || null,
          best_price_received: best_price_received || 0,
          price_percentage: dataset.price_percentage || 0,
          price_given: price_given || 0,
          status,
          delivery_cost: delivery_cost
            ? { DeliveryCost: delivery_cost }
            : { DeliveryCost: 0, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0 },
          statusValue: status === "postponed"
            ? new Date(moredetails.statusValue)
            : moredetails.statusValue || null,
          remarks: moredetails.remarks || "",
          f_date: dayjs(moredetails.f_date) || null,
          warranty: moredetails.warranty || 0,
        };

        return acc;
      },
      { datasetMap: {}, initialPriceValues: {} }
    );

    // Update state in optimal sequence
    setquerySet(data);
    setQueryDataMap(datasetMap);
    setPriceValues(initialPriceValues);
    setSupplierNumbersSet()
    // Defer non-critical operation
    setTimeout(() => filter_queryset_tabchange(currentTabState, data), 0);
  };
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleFileChange = (info) => {
    let newFileList = [...info.fileList];

    newFileList.map((file) => {
      if (file?.response) {
        return file.response;
      }
    });
    setFileList(newFileList);
    if (info.file.status === 'done') {
      setIsQsDisabled(false);
    }
  };
  const beforeUpload = (file) => {
    setIsQsDisabled(true);
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/webp';
    if (!isJpgOrPng) {
      WarningSnackbar('You can only upload JPG/PNG file!');
      setIsQsDisabled(false);
      return Upload.LIST_IGNORE;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      WarningSnackbar('Image must smaller than 2MB!');
      setIsQsDisabled(false);
      return Upload.LIST_IGNORE;
    }

    // Apply watermark before upload
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const originalImg = new window.Image();
        originalImg.onload = () => {
          const watermarkImg = new window.Image();
          watermarkImg.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = originalImg.naturalWidth;
            canvas.height = originalImg.naturalHeight;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(originalImg, 0, 0);

            const wmMaxWidth = Math.min(220, canvas.width * 0.35);
            const wmScale = wmMaxWidth / watermarkImg.naturalWidth;
            const wmW = watermarkImg.naturalWidth * wmScale;
            const wmH = watermarkImg.naturalHeight * wmScale;
            const wmX = (canvas.width - wmW) / 2;
            const wmY = (canvas.height - wmH) / 2;

            ctx.globalAlpha = 0.125;
            ctx.drawImage(watermarkImg, wmX, wmY, wmW, wmH);
            ctx.globalAlpha = 1;

            canvas.toBlob(blob => {
              resolve(new File([blob], file.name, { type: 'image/jpeg' }));
            }, 'image/jpeg', 0.95);
          };
          watermarkImg.onerror = reject;
          watermarkImg.src = uzdLogo;
        };
        originalImg.onerror = reject;
        originalImg.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };


  const handleSubmit = (send_wa) => {
    //split the below if condition to check for each field
    if (make_data?.length == 0 && send_wa) {
      WarningSnackbar("Please Select one Supplier group minimum");
      return;
    }
    if (!brand_data && send_wa) {
      WarningSnackbar("Please Select a Make");
      return;
    }
    if (!queryOrigin && send_wa) {
      WarningSnackbar("Please Select the origin of the query");
      return;
    }
    if (!model_data && send_wa) {
      WarningSnackbar("Please Select a Model");
      return;
    }
    if (!bodypart_data && send_wa) {
      WarningSnackbar("Please Enter a PartName");
      return;
    }
    if (edit ? false : !fileList && send_wa) {
      WarningSnackbar("Please Select an Image");
      return;
    }
    if (!year_data && send_wa) {
      WarningSnackbar("Please Select a Year");
      return;
    }
    if (!phone_data && send_wa) {
      WarningSnackbar("Please add customer mobile number");
      return;
    }
    if (chassisno_data && chassisno_data.length < 17 && send_wa) {
      WarningSnackbar("Please Enter a Valid Chassis Number");
      return;
    }
    if (fileList.length == 0 && send_wa) {
      WarningSnackbar("Please Add Image(s)");
      return;
    }
    if (!supplier_score && send_wa) {
      WarningSnackbar("Please Select Supplier Groups");
      return;
    }

    if (followupMsg && send_wa) {
      AntdModal.confirm({
        title: 'Schedule Auto-Replies',
        content: 'Are you sure you want to schedule auto-replies for this query?',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => setFollowupMsg(true),
        onCancel: () => setFollowupMsg(false),
      })
    }

    //this one to check if at least the customer name is added while saving an incomplete query
    if (!send_wa && !phone_data) {
      WarningSnackbar("Please enter customer information at least");
      return;
    }

    followupMsg ? InfoSnackbar("Scheduling auto-replies for this query...") : InfoSnackbar("Skipping auto-replies for this query...");


    // Proceed with your form submission or further processing
    const formData = {
      query_id: queryidEdit,
      make: make_data,
      chassisNo: chassisno_data,
      brand: brand_data,
      model: model_data,
      cylinders: cylinder_data?.toString().trim() || "",
      model_details: model_details_data?.toString().trim(),
      year: year_data ? dayjs(year_data)?.format("YYYY") : "",
      region: region_data,
      bodypart: bodypart_data,
      queryOrigin: queryOrigin,
      phone: phone_data?.toString()?.trim(),
      image: fileList?.map((file) => file?.response?.replace('/', '') ? file?.response?.replace('/', '') : file?.url?.replace(`${API_DOMAIN}/`, '')),
      user: authState.id,
      user_name: authState.name,
      queryidEdit: queryidEdit,
      followupMsg: followupMsg,
      sendQidToWati: sendQidToWati,
      send_wa,
      supplier_score
    };

    InfoSnackbar("Sending query....");
    setIsQsDisabled(true);
    axios.post(API_DOMAIN + "/whatsapp/add_querysetV3", { formData, api_secret: "uzdpart" }, head)
      .then((res) => {
        if (res.data.success) {
          setPriceHistory([]);
          setIsQsDisabled(false);
          if (followupMsg) SuccessSnackbar("Auto-replies Scheduled Successfully!");
          if (isTabFocusedRef.current) {
            SuccessSnackbar("Query ID " + res?.data?.data[0]?.query_id + " processed successfully!");
            //this is to initiate the automatic message sending to WATI 

            // window.confirm("DO you want to send the 'Query ID details' message to WATI?")
          } else {
            showNotification("Query (" + res?.data?.data[0]?.query_id + ") Succeeded", "Query with ID " + res?.data?.data[0]?.query_id + " has been processed successfully!", null);
          }
          handleClose();
        } else {
          if (isTabFocusedRef.current) {
            ErrorSnackbar("Query ID " + res?.data?.data[0]?.query_id + " Failed to Process!\nPlease try again");
            ErrorSnackbar(res.data.message);
          } else {
            showNotification("Query (" + res?.data?.data[0]?.query_id + ") Failed", "Query with ID " + res?.data?.data[0]?.query_id + " has Failed to process!\nPlease try again later.", null);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        ErrorSnackbar("Failed to process Queryset! Try again later\n" + error.message);
        setIsQsDisabled(false);
        // document.getElementById("send_query_btn").innerHTML = "Try Again...";
      }).finally(() => {
        // Enable the button again whether success or failure
        setIsQsDisabled(false);
        // document.getElementById("send_query_btn").innerHTML = "Try Again...";
      });
  };
  const set_data_to_edit_to_modal = (data) => {
    set_make_data([]);
    setModelSet([]);
    setQueryOrigin(data?.moredetails?.queryOrigin?.[0]?.value || null);
    set_make_data(typeof data?.sup_set == 'string' ? JSON.parse(data?.sup_set).map(e => e.value) : data?.sup_set);
    const brand_id = data?.make ? brandSet.filter((e) => e.label == data?.make)[0].value : null;
    set_brand_data(brand_id);
    if (brand_id) load_models(brand_id, data?.model);
    //due to async nature of setState modelSet doesn't load in a timely fashion so setting model value has been moved into load_models
    set_model_details_data(data?.model_details);

    set_bodypart_data(data?.body_part ? partsDataSet.filter((e) => data?.body_part.split(",").includes(e.label)).map(e => e.value) : null);
    set_year_data(dayjs(new Date(`${data?.year}-01-01`)).format("YYYY-MM-DD"));
    set_chassisno_data(data?.chassis_no);
    set_cylinder_data(data?.cylinder);
    set_region_data(data?.region ? regionDataSet.filter((e) => e.label == data?.region)[0].value : null);
    set_phone_data(data?.phone);
    setFileList(data?.image ? data?.image.map((img) => ({ url: API_DOMAIN + '/' + img })) : null);
    handleOpen();
  }
  const handleQueryDuplicate = (data) => {
    setQueryModalHeading(`Cloning the query (${data?.query_id}) To create a new one`);
    set_data_to_edit_to_modal(data);
  }
  const handleQueryEdit = (data) => {
    setQueryModalHeading(`Editing the query (${data?.query_id})`);
    set_queryid(data?.query_id);
    set_data_to_edit_to_modal(data);
  }
  const handleQueryUpdate = (query_id, updates, timelineEntry) => {
    if (updates.supplier !== undefined) {
      const updateRow = (prev) =>
        prev?.map(e => e?.query_id == query_id ? { ...e, supplier: updates.supplier } : e);
      setquerySet(updateRow);
      setquerySetTable(updateRow);
    }

    const existingRow = queryDataMap[query_id] || {};
    const existingMoredetails = existingRow.moredetails || {};

    const updatedMoredetails = {
      ...existingMoredetails,
      ...(updates.remarks !== undefined && { remarks: updates.remarks }),
      ...(updates.f_date !== undefined && { f_date: updates.f_date }),
      ...(updates.warranty !== undefined && { warranty: updates.warranty }),
      ...(updates.mdetails || {}),
    };
    if (updates.status && updates.status !== 'Postponed') {
      updatedMoredetails.statusValue = null;
    }

    const currentTimeline = existingRow.timeline ?? [];
    const newEntries = Array.isArray(timelineEntry) ? timelineEntry : timelineEntry ? [timelineEntry] : [];
    const updatedTimeline = newEntries.length ? [...currentTimeline, ...newEntries] : currentTimeline;

    const payload = {
      query_id: existingRow.query_id,
      user: existingRow.user,
      sup_set: existingRow.sup_set,
      date: existingRow.date,
      timeline: updatedTimeline,
      make: existingRow.make,
      model: existingRow.model,
      model_details: existingRow.model_details,
      chassis_no: existingRow.chassis_no,
      cylinder: existingRow.cylinder,
      cus_name: existingRow.cus_name,
      phone: existingRow.phone,
      region: existingRow.region,
      year: existingRow.year,
      body_part: existingRow.body_part,
      best_price_received: updates.best_price_received ?? existingRow.best_price_received,
      supplier: updates.supplier !== undefined ? updates.supplier : existingRow.supplier,
      price_given: updates.price_given ?? existingRow.price_given,
      image: existingRow.image,
      part_number: existingRow.part_number,
      status: updates.status || existingRow.status,
      delivery_cost: updates.delivery_cost ?? existingRow.delivery_cost,
      moredetails: updatedMoredetails,
      current_user: authState.id
    };

    return axios.post(API_DOMAIN + "/whatsapp/update_querysetV2", payload, head)
      .then(() => {
        setQueryDataMap(prev => ({
          ...prev,
          [query_id]: { ...prev[query_id], ...updates, timeline: updatedTimeline, moredetails: updatedMoredetails },
        }));
        if (updates.status) {
          handlePriceValueChanges(query_id, "status", updates.status);
          setquerySet(prev => prev?.map(e => e?.query_id == query_id ? { ...e, status: updates.status } : e));
        }
        SuccessSnackbar("Updated successfully!");
      })
      .catch(() => ErrorSnackbar("Update failed."));
  };

  const update_available_supplier_count = async () => {
    try {
      const final_make_data = Array.isArray(make_data) ? make_data : [make_data]
      if (final_make_data?.length > 0) {
        setLoadApiSuppCount(true);
        var res = await axios.post(API_DOMAIN + "/whatsapp/get_suppliers", { make: final_make_data, api_secret: "uzdpart" }, head)
        if (res.data.success) {
          setSuppCount(res.data.data.length);
        }
      } else {
        setSuppCount(0);
      }
    } catch (error) {

    }
    finally {
      setLoadApiSuppCount(false);
    }
  };

  const handleBrandChange = (value) => {
    set_model_data(null);
    set_brand_data(value);
    //auto selecting of supplier tags
    // if (value) {
    //   const brandName = brandSet?.find(e => e?.value == value)?.label?.toLowerCase();
    //   const matched = makeSet?.filter(e => e?.label?.toLowerCase() === brandName || e?.label?.toLowerCase()?.includes(brandName) || (e?.label?.toLowerCase()?.includes("body parts") && e?.label?.toLowerCase()?.includes(brandName?.toLowerCase())));
    //   const result = matched ? matched?.length > 1 ? matched?.map(e => e?.value) : matched?.[0]?.value : null;
    //   set_make_data(result)
    load_models(value);
    // } else {
    //   setModelSet([]);
    //   set_model_data(null);
    //   set_make_data(null);
    // }
  };
  const [loadingPriceHistory, setLoadingPriceHistory] = useState(false);
  const load_last_month_prices = async () => {
    if (brand_data && model_data) {
      setLoadingPriceHistory(true);
      try {
        const res = await axios.post(API_DOMAIN + "/whatsapp/get_last_month_prices", { make: brand_data, model: model_data, part: bodypart_data, year: year_data, cylinders: cylinder_data, region: region_data, }, head)

        if (res.data.success) {
          setPriceHistory(res.data.data);
        }
        else {
          setPriceHistory(null);
        }

      } catch (error) {
        ErrorSnackbar(error.message);
      }
      finally {
        setLoadingPriceHistory(false);
      }
    }
    else {
      setPriceHistory(null)
    }
  };

  const handle_model_change = (value) => {
    set_model_data(value);
    // if (value) {

    //   //since model value is id, this finds the model name
    //   const modelName = modelSet?.find(e => e?.value == value)?.label?.toLowerCase();

    //   //here the same with brand name is done
    //   const brandName = brandSet?.find(e => e?.value == brand_data)?.label?.toLowerCase();

    //   //some times the supplier group consists of only one value, that times we need to make it into an array manually, other times it is an array because of its multiple values by default.
    //   const make_data_final = Array.isArray(make_data) ? make_data : [make_data];
    //   const supplier_labels = makeSet.filter(e => make_data_final.includes(e.value));

    //   //here, we again loop through the already selected supplier groups with fuzzy match of the model name and exact match of brand name
    //   var matched = supplier_labels?.filter(e => {
    //     const label = e?.label?.toLowerCase();
    //     return (
    //       label === modelName ||
    //       label?.split(" ").some(word => modelName?.split(" ")?.includes(word)) ||
    //       (label?.toLowerCase()?.includes("body parts") && label?.toLowerCase()?.includes(brandName?.toLowerCase()))
    //     );
    //   });

    //   if (matched?.length > 0) {
    //     const matched_brandnames = supplier_labels?.filter(e => {
    //       const label = e?.label?.toLowerCase();
    //       return (
    //         label === brandName || (label?.toLowerCase()?.includes("body parts") && label?.toLowerCase()?.includes(brandName?.toLowerCase()) && label?.toLowerCase()?.includes(modelName?.toLowerCase()))
    //       );
    //     });
    //     if (matched_brandnames?.length > 0)
    //       matched.push(...matched_brandnames);
    //   }

    //   //Now making the final found supplier groups into required format
    //   const result = matched?.length > 0 ? matched?.length > 1 ? matched?.map(e => e?.value) : matched?.[0]?.value : null;
    //   if (result) {
    //     set_make_data(result)
    //   }
    // }
    // else {
    //   handleBrandChange(brand_data);
    // }
  };

  useEffect(() => {
    load_last_month_prices();
  }, [brand_data, model_data, bodypart_data, year_data, cylinder_data, region_data]);

  const handleCusNameChange = (value) => {
    if (value?.toString()?.startsWith("05")) {
      value = value?.replace(/^05/, '9715');
    }
    set_phone_data(value);
  };


  const handleExcelClick = () => {
    try {
      if (querySetTable?.length > 0) {
        SuccessSnackbar(
          `Exporting data to Excel format, from ${dayjs(startDate).format(
            "DD-MM-YYYY"
          )} to ${dayjs(endDate).format("DD-MM-YYYY")}${currentTabState != "" ? ", with status " + currentTabState : "."
          } contains ${querySetTable.length} rows.`
        );
        generateExcel(querySetTable, currentTabState, startDate, endDate, supplierIdToName);
      }
      else {
        InfoSnackbar(`Refine your search conditions to have some results in-order to export to Excel.`);
      }
    } catch (error) {

    }
  };
  const handlePdfClick = () => {
    try {
      if (querySetTable?.length > 0) {
        SuccessSnackbar(
          `Preparing PDF from ${dayjs(startDate).format("DD-MM-YYYY")} to ${dayjs(
            endDate
          ).format("DD-MM-YYYY")} ${currentTabState != "" ? "with status " + currentTabState : "."
          } contains ${querySetTable.length} rows.`
        );
        generatePDF(querySetTable, currentTabState, startDate, endDate, supplierIdToName);
      }
      else {
        InfoSnackbar(`Refine your search conditions to have some results in-order to generate PDF.`);
      }
    } catch (error) {

    }
  };

  const handleModalAdd = async (e, title) => {
    title = title.trim();
    if (!modal_data) {
      WarningSnackbar("Please Enter a Value first");
      return;
    }
    set_adding_modal_loading(true)
    switch (title) {
      case "Add New Region":
        try {
          var res = await axios.post(API_DOMAIN + "/whatsapp/region_add_update", { region: modal_data }, head)
          if (res.data.success) {
            const regionTemp = res.data.data.map((item) => ({
              value: item.id,
              label: item.region,
            }));
            setRegionDataSet(regionTemp);
            set_region_data(regionTemp.find((e) => e.label == modal_data).value);
            SuccessSnackbar("Region added successfully");
            handleCloseAddModal();
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          set_adding_modal_loading(false);
          break;
        }
      case "Add New Make":
        try {
          var res = await axios.post(API_DOMAIN + "/whatsapp/add_makes_v2", { name: modal_data }, head)
          if (res.data.success) {
            const makeSetTemp = res.data.data.map((item) => ({
              value: item.id,
              label: item.name,
            }));
            setbrandSet(makeSetTemp);
            set_brand_data(makeSetTemp.find((e) => e.label == modal_data).value);
            SuccessSnackbar("Make added successfully");
            handleCloseAddModal();
          } else {
            ErrorSnackbar(res.data.message);
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          set_adding_modal_loading(false)
          break;
        }
      case "Add New Part":
        try {
          var res = await axios.post(API_DOMAIN + "/whatsapp/add_new_part_info", { value: modal_data }, head)
          if (res.data.success) {
            setPartsDataSet(res.data.data);
            SuccessSnackbar("Part Info added successfully");
            handleCloseAddModal();
          } else {
            ErrorSnackbar(res.data.message);
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          set_adding_modal_loading(false);
          break;
        }
      case "Add New Query source":
        try {
          var res = await axios.post(API_DOMAIN + "/whatsapp/add_new_query_origin", { value: modal_data, mode: "query_source" }, head)
          if (res.data.success) {
            setqueryOriginSet(res.data.data);
            setQueryOrigin(res.data.data.find(e => e.label == modal_data).value)
            SuccessSnackbar("Query origin added successfully");
            handleCloseAddModal();
          } else {
            ErrorSnackbar(res.data.message);
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          set_adding_modal_loading(false)
          break;
        }
      case "Add New '" + brandSet.find((value) => value.value == brand_data).label + "' Model":
        try {
          var res = await axios.post(API_DOMAIN + "/whatsapp/add_model_v2", { make: brand_data, model: modal_data }, head)
          if (res.data.success) {
            const ModelTemp = res.data.data.map((item) => ({
              value: item.id,
              label: item.model,
            }));
            setModelSet(ModelTemp);

            set_model_data(ModelTemp.find((element) => element.label == modal_data).value);
            SuccessSnackbar("Model added successfully");
            handleCloseAddModal();
          } else {
            WarningSnackbar(res.data.message);
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          set_adding_modal_loading(false)
          break;
        }
      default:
        AntdModal.warning({ title: 'Invalid Action', content: 'Watch where you are clicking!' })
        break;
    }
  };
  const handleRegionChange = (value) => {
    set_region_data(value);
  };
  const onSearchDateChange = (dates) => {
    if (dates) {
      const [start, end] = dates;
      setStartDate(start);
      setEndDate(end);
    }
    else {
      setStartDate(null);
      setEndDate(null);
    }
  };

  const reload_cost_prices = () => {
    axios.post(API_DOMAIN + "/whatsapp/get_costprices", head).then((res) => {
      if (res.data.success) {
        setCostPriceSet(res.data.data);
      }
    });
  };
  const reload_customers = async (search) => {
    set_cus_name_loading(true)

    if (search?.toString()?.startsWith("05")) {
      search = search?.replace(/^05/, '9715');
    }
    try {
      const res = await axios.post(API_DOMAIN + "/whatsapp/get_customers", { search })
      if (res.data.success) {
        const filtered_for_select = res.data.data.map((customer) => ({
          value: customer.customer_mobile,
          label: customer.customer_name
        }))
        set_cus_name_set_for_select(filtered_for_select);
      }
    } catch (error) {
      ErrorSnackbar(error.message)
    }
    finally {
      set_cus_name_loading(false);
    }
  };

  const reload_suppliers = async () => {
    var res = await axios.post(API_DOMAIN + "/whatsapp/get_suppliersV2", head)
    setsupplierSet(res.data.data);
    // console.log("res.data.data = " + JSON.stringify(res.data.data));
    var supSet = supplierSet;
    supplierIdToName = supSet.reduce((map, supplier) => {
      map[supplier.id] = supplier.name;
      return map;
    }, {});

  };
  const reload_makes = () => {
    axios.post(API_DOMAIN + "/whatsapp/get_supplier_tags", head).then((res) => {
      if (res.data.success) {
        var makeSetTemp = [];
        // const transformedQuerySet = makeSetTemp.map(item => item.name);
        for (let i = 0; i < res.data.data.length; i++) {
          makeSetTemp.push({
            value: res.data.data[i].id,
            label: res.data.data[i].name,
          });
        }
        setmakeSet(makeSetTemp);
      }
    });
  };
  const reload_querysets = () => {
    var from = dayjs(startDate).format("YYYY-MM-DD");
    var to = dayjs(endDate).format("YYYY-MM-DD");
    setLoading(true);
    axios.post(API_DOMAIN + "/whatsapp/get_querysets", { from, to, id: authState.id }, head).then((res) => {
      setLoading(false);
      if (res.data.success) {
        handling_setquerySet(res.data.data);
      }
    })
      .catch((error) => {
        console.error("Error reloading querysets:", error);
        setLoading(false);
      });

    // setTimeout(() => {
    //     reload_querysets(head);
    // }, 5000); //repeat call after 3 minutes (180000 milliseconds)
  };
  const reload_region = () => {
    axios.post(API_DOMAIN + "/whatsapp/get_region", head).then((res) => {
      const regionTemp = res.data.data.map((item) => ({
        value: item.id,
        label: item.region,
      }));
      setRegionDataSet(regionTemp);
    });
  };
  const reload_brands = async (value = "") => {
    try {
      set_model_data(null);
      const res = await axios.post(API_DOMAIN + "/whatsapp/get_makes_v2", {
        name: value,
      }, head);
      if (res.data.success) {
        const makeSetTemp = res.data.data.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setbrandSet(makeSetTemp);
      }
    } catch (error) {
      console.error("Error reloading brands:", error);
    }
  };
  const load_models = async (value, model = null) => {
    set_loading_models(true);
    try {
      const res = await axios.post(API_DOMAIN + "/whatsapp/get_models_v2", { make: value });
      if (res.data.success) {
        const ModelTemp = res.data.data.map((item) => ({
          value: item.id,
          label: item.model,
        }));
        setModelSet(ModelTemp);
        if (model) {
          set_model_data(ModelTemp.filter((e) => e.label == model)[0].value);
        }
      }
    } catch (error) {
      ErrorSnackbar(`Error Fetching Models ${error.message}`);
    }
    finally {
      set_loading_models(false);
    }
  };
  const load_users = () => {
    axios.get(API_DOMAIN + "/whatsapp/get_users", head).then((res) => {
      if (res.data.success) {
        setUsersSet(res.data.data.map(element => ({ value: element.id, label: element.name })));
      }
    });
  };

  const computePriceToPercent = (bestPrice, givenPrice, DeliveryCost) => {
    return (
      ((parseFloat(givenPrice) -
        parseFloat(bestPrice) -
        parseFloat(DeliveryCost)) /
        parseFloat(bestPrice)) *
      100
    ).toFixed(2);
  };

  const computePercentToPrice = (bestPrice, percentage, DeliveryCost) => {
    // alert("bestPrice=" + bestPrice + "percentage= " + percentage + "DeliveryCost=" + DeliveryCost)
    const price = (
      (parseFloat(bestPrice) * parseFloat(percentage)) / 100 +
      parseFloat(bestPrice) +
      parseFloat(DeliveryCost)
    ).toFixed(2);
    return price;
  };

  const handlePriceValueChanges = (query_id, field, value) => {
    setPriceValues((prevPriceValues) => {
      const updatedPriceValues = {
        ...prevPriceValues,
        [query_id]: {
          ...prevPriceValues[query_id],
          [field]: value,
        },
      };
      return updatedPriceValues;
    });
  };

  //best price received change handler
  const handleBestPriceChange = (query_id, best_price_received) => {
    handlePriceValueChanges(query_id, "best_price_received", best_price_received);

    if (best_price_received) {
      var cost_data = (best_price_received != 0
        ? costPriceSet.find((item) => best_price_received >= item.MinPrice && best_price_received <= item.MaxPrice)
        : 0) || { DeliveryCost: 0, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0 };

      handlePriceValueChanges(query_id, "price_percentage", cost_data.GP_Percentage);
      handlePriceValueChanges(query_id, "delivery_cost", cost_data);

      handlePriceValueChanges(query_id, "price_given", 0);

      const price_percentage = cost_data.GP_Percentage;

      if (price_percentage != 0) {
        var price = computePercentToPrice(best_price_received, price_percentage, cost_data.DeliveryCost);
        handlePriceValueChanges(query_id, "price_given", price);
      }
    } else {
      handlePriceValueChanges(query_id, "price_percentage", 0);
      handlePriceValueChanges(query_id, "price_given", 0);
      handlePriceValueChanges(query_id, "delivery_cost", {
        DeliveryCost: 0,
        GP_Percentage: 0,
        MinPrice: 0,
        MaxPrice: 0,
      });
    }
  };

  //percentage number change handler
  const handlePercentageChange = (query_id, percent) => {
    const best_price = priceValues[query_id]["best_price_received"] ?? 0;
    if (best_price == 0) {
      AntdModal.warning({ title: 'Missing Price', content: 'Please enter the Best Price received for the item first.' });
    } else {
      handlePriceValueChanges(query_id, "price_percentage", percent);

      const deliveryCost = priceValues[query_id]["delivery_cost"]["DeliveryCost"];

      if (percent != 0) {
        var price = computePercentToPrice(best_price, percent, deliveryCost);
        handlePriceValueChanges(query_id, "price_given", price);
      } else {
        handlePriceValueChanges(query_id, "price_given", best_price + deliveryCost);
      }
    }
  };

  //given price change handler
  const handleGivenPriceChange = (query_id, given_price) => {
    const best_price = priceValues[query_id]["best_price_received"] ?? 0;

    if (best_price == 0) {
      AntdModal.warning({ title: 'Missing Price', content: 'Please enter the Best Price received for the item first.' });
    } else if (given_price == 0) {
      handlePriceValueChanges(query_id, "price_given", given_price);
      handlePriceValueChanges(query_id, "price_percentage", 0);
      handlePriceValueChanges(query_id, "delivery_cost", {
        DeliveryCost: 0,
        GP_Percentage: 0,
        MinPrice: 0,
        MaxPrice: 0,
      });
    } else {
      handlePriceValueChanges(query_id, "price_given", given_price);
      const deliveryCost =
        priceValues[query_id]["delivery_cost"]["DeliveryCost"];

      const percentage = computePriceToPercent(best_price, given_price, deliveryCost);
      handlePriceValueChanges(query_id, "price_percentage", percentage);
    }
  };

  //given price change handler
  const handleDeliverycostChange = (query_id, delivery_cost) => {
    const best_price = priceValues[query_id]["best_price_received"] ?? 0;

    if (best_price == 0) {
      AntdModal.warning({ title: 'Missing Price', content: 'Please enter the Best Price received for the item first.' });
    } else {
      if (delivery_cost) {
        handlePriceValueChanges(query_id, "delivery_cost", { DeliveryCost: delivery_cost, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0, });

        const percentage = priceValues[query_id]["price_percentage"];

        const given_price = computePercentToPrice(best_price, percentage, delivery_cost);
        handlePriceValueChanges(query_id, "price_given", given_price);
      } else {
        handlePriceValueChanges(query_id, "delivery_cost", { DeliveryCost: delivery_cost, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0, });

        const percentage = priceValues[query_id]["price_percentage"];

        const given_price = computePercentToPrice(best_price, percentage, 0);
        handlePriceValueChanges(query_id, "price_given", given_price);
      }
    }
  };

  const handleSupplierPriceUpdate = (query_id) => {
    const { supplier, best_price_received, price_given, status } = priceValues[query_id];
    const delivery_cost = priceValues[query_id].delivery_cost?.DeliveryCost ?? 0;
    const updates = { supplier, best_price_received, price_given, delivery_cost };
    const timelineEntries = [buildTimeline('supplier_price')];
    if (status === 'Waiting for Price' && best_price_received && price_given) {
      updates.status = 'Waiting for confirmation';
      handlePriceValueChanges(query_id, 'status', 'Waiting for confirmation');
      timelineEntries.push(buildTimeline('status', 'Waiting for confirmation'));
    }
    setSupplierPriceLoading(prev => ({ ...prev, [query_id]: true }));
    handleQueryUpdate(query_id, updates, timelineEntries)
      .finally(() => setSupplierPriceLoading(prev => ({ ...prev, [query_id]: false })));
  };

  const handleMiscUpdate = (query_id) => {
    const { status, remarks, warranty } = priceValues[query_id];
    const f_date = priceValues[query_id]?.f_date ? dayjs(priceValues[query_id].f_date).format('YYYY-MM-DD') : null;
    const mdetails = queryDataMap[query_id]?.mdetails || {};
    const updates = { status, remarks, f_date, warranty, mdetails };
    setMiscLoading(prev => ({ ...prev, [query_id]: true }));
    handleQueryUpdate(query_id, updates, buildMiscTimeline(query_id, updates))
      .finally(() => setMiscLoading(prev => ({ ...prev, [query_id]: false })));
  };

  //WATI Message approval stuff
  const [wati_msgs_waiting_approval, set_wati_msgs_waiting_approval] = useState([])

  useSocketEvents([
    {
      event: "wati_message_scheduled",
      handler: (values) => {
        set_wati_msgs_waiting_approval(values);
        InfoSnackbar("Incoming new WATI message to approve!");
        playChime(wati_msg_approval_incoming_sound);
      },
    },
    {
      event: "wati_message_approved",
      handler: (values) => {
        InfoSnackbar(`Your WATI Qoute for Query ID : ${values?.queryset?.query_id} has been approved!`);
      },
    },
    {
      event: "wati_message_rejected",
      handler: (values) => {
        WarningSnackbar(`Your WATI Qoute for Query ID : ${values?.query_id || "Unknown"} has been removed!\nContact Admin ${values?.deleted_admin || ""}`);
      },
    },
    {
      event: "wati_message_updated_list",
      handler: (values) => {
        set_wati_msgs_waiting_approval(values);
        InfoSnackbar(`WATI Quotes approval list updated!`);
      },
    },
    {
      event: "queryset_updated",
      handler: (values) => {
        values = values?.[0];
        if (values) {
          setquerySet((prev) =>
            prev?.map(e =>
              e?.query_id == values?.query_id
                ? values
                : e
            )
          );

          setquerySetTable((prev) =>
            prev?.map(e =>
              e?.query_id == values?.query_id
                ? values
                : e
            )
          );

          setPriceValues(prevData => {
            if (!(values?.query_id)) return prevData; // Early return if no query_id

            const {
              best_price_received = 0,
              price_given = 0,
              status,
              delivery_cost,
              moredetails = {}
            } = values;

            const numerator = price_given - best_price_received - delivery_cost;
            const percentage = (numerator / best_price_received) * 100;
            const price_percentage = isNaN(percentage) ? 0 : percentage.toFixed(2);

            return {
              ...prevData,
              [values?.query_id]: {
                best_price_received,
                price_percentage,
                price_given,
                status,
                delivery_cost: delivery_cost
                  ? { DeliveryCost: delivery_cost }
                  : { DeliveryCost: 0, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0 },
                statusValue: status === "postponed"
                  ? new Date(moredetails.statusValue)
                  : moredetails.statusValue || null,
                remarks: moredetails.remarks || "",
                f_date: dayjs(moredetails.f_date) || null,
                warranty: moredetails.warranty || 0
              }
            };
          });
          // filter_queryset_tabchange(currentTabState, data);
          InfoSnackbar(`Query #${values?.query_id} got updated!`);
          playChime(queryset_updated_notif_sound);
        }
      },
    },
    {
      event: "queryset_deleted",
      handler: (value) => {
        if (value) {
          setquerySet(prev =>
            prev?.filter(item => item?.query_id !== value) ?? []
          );

          setquerySetTable(prev =>
            prev?.filter(item => item?.query_id !== value) ?? []
          );

          setPriceValues(prevData => {
            const newData = { ...prevData };
            delete newData[value];
            return newData;
          });
          // filter_queryset_tabchange(currentTabState, data);
          InfoSnackbar(`Query #${value} got deleted!`);
          playChime(queryset_deleted_notif_sound);
        }
      },
    },
    // {
    //   event: "new_query_added",
    //   handler: (value) => {
    //     value = value?.[0];
    //     if (value && searchTerm == null && (searchUser == null || searchUser == value?.user) && dayjs(value?.date).isSame(dayjs(), 'day')) {
    //       console.log(`searchTerm = `, searchTerm);
    //       console.log(`querySet = `, querySetTable);
    //       console.log(`value = `, value);
    //       console.log(`teriyaki Boys = `, querySetTable.find((e) => e.query_id == value.query_id));

    //       if (querySetTable.find((e) => e.query_id == value.query_id)?.query_id) {
    //         setquerySet(prev =>
    //           prev.map(e => e?.query_id == value?.query_id ? value : e)
    //         );
    //         setquerySetTable(prev =>
    //           prev.map(e => e?.query_id == value?.query_id ? value : e)
    //         );
    //       }
    //       else {
    //         setquerySet(prev =>
    //           [value, ...prev].sort((a, b) => b.query_id - a.query_id)
    //         );


    //         setquerySetTable(prev =>
    //           [value, ...prev].sort((a, b) => b.query_id - a.query_id)
    //         );

    //       }
    //       setPriceValues(prevData => {
    //         if (!(value?.query_id)) return prevData; // Early return if no query_id

    //         const {
    //           best_price_received = 0,
    //           price_given = 0,
    //           status,
    //           delivery_cost,
    //           moredetails = {}
    //         } = value;

    //         const numerator = price_given - best_price_received - delivery_cost;
    //         const percentage = (numerator / best_price_received) * 100;
    //         const price_percentage = isNaN(percentage) ? 0 : percentage.toFixed(2);

    //         return {
    //           ...prevData,
    //           [value?.query_id]: {
    //             best_price_received,
    //             price_percentage,
    //             price_given,
    //             status,
    //             delivery_cost: delivery_cost
    //               ? { DeliveryCost: delivery_cost }
    //               : { DeliveryCost: 0, GP_Percentage: 0, MinPrice: 0, MaxPrice: 0 },
    //             statusValue: status === "postponed"
    //               ? new Date(moredetails.statusValue)
    //               : moredetails.statusValue || null,
    //             remarks: moredetails.remarks || "",
    //             f_date: dayjs(moredetails.f_date) || null,
    //             warranty: moredetails.warranty || 0
    //           }
    //         };
    //       });

    //       // filter_queryset_tabchange(currentTabState, data);
    //       InfoSnackbar(`New Query #${value?.query_id} got posted!`);
    //       playChime(queryset_added_notif_sound);
    //       // flashRowWithPagination(value?.query_id,)
    //     }
    //   },
    // },
  ]);

  const [wati_msgs_waiting_approval_modal, set_wati_msgs_waiting_approval_modal] = useState(false)
  const handleOpenWatiApproval = () => {
    set_wati_msgs_waiting_approval_modal(true)
  }
  const handleCloseWatiApproval = () => {
    set_wati_msgs_waiting_approval_modal(false)
  }

  const handleRemarksChange = (query_id, value) => {
    setPriceValues((prevData) => ({
      ...prevData,
      [query_id]: {
        ...prevData[query_id],
        remarks: value,
      },
    }));
  }

  const handle_f_date_Change = (query_id, value) => {
    setPriceValues((prevData) => ({
      ...prevData,
      [query_id]: {
        ...prevData[query_id],
        f_date: value,
      },
    }));
  }

  const handleWarrantyChange = (query_id, value) => {
    setPriceValues((prevData) => ({
      ...prevData,
      [query_id]: {
        ...prevData[query_id],
        warranty: value,
      },
    }));
  }

  const get_remarks = () => {
    axios.get(API_DOMAIN + "/whatsapp/get_remarks", head).then((res) => {
      if (res.data.success) {
        setRemarksSet(res.data.data);
      }
    });
  }

  const get_parts = () => {
    axios.post(API_DOMAIN + "/whatsapp/get_parts_info", head).then((res) => {
      if (res.data.success) {
        setPartsDataSet(res.data.data);
      }
    });
  }

  const get_query_origins = async () => {
    const result = await axios.post(API_DOMAIN + "/whatsapp/get_misc_mode", { mode: "query_source" });
    if (result.data.success) {
      setqueryOriginSet(result.data.data);
    }
  }

  const get_waiting_for_approval_wati_messages = async () => {
    const result = await axios.get(API_DOMAIN + "/whatsapp/get_scheduled_wati_general_messages");
    if (result.data.success) {
      set_wati_msgs_waiting_approval(result.data.data);
    }
  }

  const get_misc_templates_origins = async () => {
    const result = await axios.post(API_DOMAIN + "/whatsapp/get_misc_mode", { mode: "wati_template_ids" });
    if (result.data.success) {
      setMiscTemplates(result.data.data);
    }
  }

  const getCarLogotypes = async () => {
    try {
      const response = await axios.get(
        `https://cdn.jsdelivr.net/gh/avto-dev/vehicle-logotypes@2.x/src/vehicle-logotypes.json`
      );
      setCarLogoTypes(response.data)
    } catch (error) {
      ErrorSnackbar("Error fetching logotypes:", error);
    }
  };

  const get_postponed_queries = async () => {
    var result = await axios.get(`${API_DOMAIN}/whatsapp/get_postponed_queries`);
    if (result.data.success) {
      const formatted_data = result?.data?.data?.map((element) => {
        // Construct the status string without unnecessary null values
        const remarks = element?.moredetails?.remarks?.trim();
        return {
          ...element,
          status: `${element?.postponed_to}\n\n(${element?.status})${remarks ? `\n\n(${remarks})` : ''}`
        };
      });

      setPostponedQuerySet(formatted_data);

    }
    else {
      ErrorSnackbar(`Error retrieving postponed queries`);
    }
  }

  const reload_query_succ_responses = () => {
    axios.post(API_DOMAIN + "/whatsapp/get_query_succ_status", { api_secret: "uzdpart" }, head)
      .then((res) => {
        if (res.data.success) {
          setQueryStatusSet(res.data.data.map(element => ({ value: element.name, label: element.name, colour: element.colour })));
        }
      })
      .catch((err) => {
        ErrorSnackbar(err.message);
      });
  }

  useEffect(() => {
    getCarLogotypes();
  }, []);

  useEffect(() => {
    const head = {
      headers: {
        accessToken: localStorage.getItem("accessToken")
      }
    };
    get_query_origins();
    get_waiting_for_approval_wati_messages();
    get_misc_templates_origins()
    load_users();
    get_postponed_queries();
    get_remarks();
    get_parts();
    reload_querysets(head);
    //this is the tags
    reload_makes(head);
    //brand names, models will load when a brand is selected
    reload_brands(head);
    //now it loads the supplierv2 data
    reload_suppliers(head);
    reload_customers(head);
    reload_region(head);
    reload_cost_prices(head);
    const waStatusCheck = async (head) => {
      setAdd_query_btn_loading(true);
      setAdd_query_btn_disabled(true);
      setBot_status("Loading Bot status...")
      try {
        const res = await axios.post(API_DOMAIN + "/whatsapp/status", { api_secret: "uzdpart" }, head)
        if (res.data.success) {
          setWhatsappStatus(res.data.data.status);
          switch (res.data.data.status.status) {
            case eventStatusMap.logged_in:
              setAdd_query_btn_disabled(false);
              setBot_status("Bot operational")
              break;
            case eventStatusMap.browserClose:
              setAdd_query_btn_disabled(false);
              setBot_status("Bot issue!")
              await axios.get(wati_DOMAIN + "/api/restart_whatsapp")
              InfoSnackbar(`Auto Restarting Whatsapp Bot, Please wait...`)
              setTimeout(() => {
                waStatusCheck();
              }, 5000);
              break;
            default:
              // await axios.get(wati_DOMAIN + "/api/restart_whatsapp")
              // InfoSnackbar(`Auto Restarting Whatsapp Bot, Please wait...`)
              setTimeout(() => {
                waStatusCheck();
              }, 3000);
              break;
          }
        } else {
          // document.getElementById("wa_status_img_small").src = yellow_error;
        }
      } catch (error) {
        ErrorSnackbar(error.message);
      }
      finally {
        setAdd_query_btn_loading(false);
      }
    };
    reload_query_succ_responses();
    try {
      if (Notification.permission === "default") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            console.log("Notification permission granted.");
          } else {
            AntdModal.info({ title: 'Notifications Blocked', content: "Please allow notifications so that you'll know when the query gets resolved." });
            console.log("Notification permission denied.");
          }
        });
      }
    } catch (error) {
      ErrorSnackbar(`Notification feature unavailable!`);
    }
    waStatusCheck();

    const handleWindowFocus = () => {
      setIsTabFocused(true);
    };

    const handleWindowBlur = () => {
      setIsTabFocused(false);
      queryDateRef?.current?.setOpen(false);
    };

    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("blur", handleWindowBlur);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("blur", handleWindowBlur);
    };
  }, []);
  useEffect(() => {
    isTabFocusedRef.current = isTabFocused;
  }, [isTabFocused]);
  useEffect(() => {
    update_available_supplier_count();
  }, [make_data]);

  const [priceValues, setPriceValues] = useState({});
  const [queryDataMap, setQueryDataMap] = useState({});
  const [supplierPriceLoading, setSupplierPriceLoading] = useState({});
  const [miscLoading, setMiscLoading] = useState({});

  const reloadQuerySet = () => {
    const doFetch = () => {
      setIsDownloadButtonDisabled(true);
      setLoading(true);
      axios.post(API_DOMAIN + "/whatsapp/get_querysets", { search: searchTerm, from: dayjs(startDate).format("YYYY-MM-DD"), to: dayjs(endDate).format("YYYY-MM-DD"), api_secret: "uzdpart", id: authState.id, user: searchUser }, head)
        .then((res) => {
          setIsDownloadButtonDisabled(false);
          if (res.data.success) {
            handling_setquerySet(res.data.data);
            setLoading(false);
            if (
              searchTerm ||
              dayjs(startDate).isValid() ||
              dayjs(endDate).isValid()
            ) {
              SuccessSnackbar("Fetched " + res.data.data.length + " search results");
            }
          }
        })
        .catch((error) => {
          ErrorSnackbar("Error fetching data, Please try again later. " + error.message);
          setLoading(false);
        });
    };

    if (!startDate && !endDate) {
      AntdModal.confirm({
        title: 'No Dates Selected',
        content: 'No dates selected. This search will scan the whole database and may take longer.',
        okText: 'Proceed',
        cancelText: 'Cancel',
        okButtonProps: { danger: true },
        onOk: doFetch,
      });
    } else {
      doFetch();
    }
  };

  const handleRowsDelete = (query_id) => {
    AntdModal.confirm({
      title: 'Delete Query',
      content: `Do you want to delete Query with ID: ${query_id}?`,
      okText: 'Delete',
      cancelText: 'Cancel',
      okButtonProps: { danger: true },
      onOk: () => {
        handleQueryUpdate(query_id, { status: 'Disabled' }, buildTimeline('disable'));
        const newData = querySet.filter((query) => query.query_id != query_id);
        setquerySet(newData);
        setTimeout(() => {
          filter_queryset_tabchange(currentTabState, newData);
        }, 0);
      },
    });
  }

  const save_settings = (settings) => {
    try {
      axios.post(API_DOMAIN + "/whatsapp/add_query_succ_status", { statuses: settings, }, head).then((res) => {
        if (res.data.success) { reload_query_succ_responses(); handleCloseSettingsModal(); } else { ErrorSnackbar(res.data.message); }
      });
    } catch (error) {
      throw error;
    }
  };

  //this cant be moved as it needs the snackbar to work, moving is inefficient
  //same applicable to all the following
  async function copyToClipboardModern(text, term) {
    try {
      await navigator.clipboard.writeText(text);
      SuccessSnackbar(term + " copied to clipboard!");
    } catch (err) {
      ErrorSnackbar(`Failed to copy : ${term}`, err);
    }
  };
  const open_wati_chat = async (id, phone) => {
    // document.getElementById(id).disabled = true;
    InfoSnackbar(`Switching to WATI chat, please wait...`);
    var result = await axios.post(`${API_DOMAIN}/whatsapp/get_chat_id_from_number`, { number: phone });
    if (result.data.success) {
      if (result.data.data.length == 0) {
        ErrorSnackbar("Something went wrong, Try again.");
      }
      else {
        const chat_id = result.data.data[0].ticket.conversationId;
        const wati_url = `https://live.wati.io/5068/teamInbox/${chat_id}?filter={%22filterType%22:0,%22channelType%22:0,%22filterChannelIds%22:[%22%22]}`
        openNewTab(wati_url);
      }
    }
    else {
      ErrorSnackbar("Failed to fetch chat info from WATI.");
    }
    // document.getElementById(id).disabled = false;
  }

  //wati templates section
  const [allTemplateData, setAllTemplateData] = useState({ open: false, record: null, templates: null, templates_temp: null, chosenTemplateID: null, chosenTemplateOut: null, finalViewOpen: false, priceValues: null, approve_temp_info: null });

  const [wati_templates_loading, set_wati_templates_loading] = useState(false);



  const loadAllTemplates = async () => {
    set_wati_templates_loading(true);
    const templates = await loadWatiTemplates();
    set_wati_templates_loading(false);
    return templates;
  }

  const prepare_wati_messages_loading = async (record) => {

    const templates = await loadAllTemplates();

    setAllTemplateData({
      open: true,
      record: record,
      templates: templates,
      templates_temp: templates,
    })


  }

  const loadWatiTemplates = async () => {
    try {
      const res = await axios.post(API_DOMAIN + "/whatsapp/get_wati_templates", { template: false }, head);
      if (res.data.success) {
        return res.data.data;
      } else {
        ErrorSnackbar("Something went wrong while fetching the templates");
      }
    } catch (error) {
      ErrorSnackbar(error.message);
    }
  };

  const rangePresets = [
    {
      label: 'Last 90 Days',
      value: [dayjs().add(-90, 'd'), dayjs()],
    },
    {
      label: 'Last 60 Days',
      value: [dayjs().add(-60, 'd'), dayjs()],
    },
    {
      label: 'Last 30 Days',
      value: [dayjs().add(-30, 'd'), dayjs()],
    },
    {
      label: 'Last 14 Days',
      value: [dayjs().add(-14, 'd'), dayjs()],
    },
    {
      label: 'Last 7 Days',
      value: [dayjs().add(-7, 'd'), dayjs()],
    },
    {
      label: 'Yesterday',
      value: [dayjs().add(-1, 'd'), dayjs().add(-1, 'd')],
    },
    {
      label: 'Today',
      value: [dayjs(), dayjs()],
    }
  ];

  const handlCloseWatiFinalView = () => {
    setAllTemplateData({
      chosenTemplateID: null,
      msg_text: null,
      moredetails: null,
      chosenTemplateOut: null,
      finalViewOpen: false,
      approval_id: null,
    })
    setApproval_message_view(false);
  }

  //the main modal to show all addresses and to manage it
  const [customerAddressManagementOpen, setCustomerAddressManagementOpen] = useState({ data: null, open: false })
  const handleCustomerAddManageOpen = (data = null) => {
    setCustomerAddressManagementOpen({ data: data, open: true })
  }
  const handleCustomerAddManageClose = () => {
    setCustomerAddressManagementOpen({ data: null, open: false })
    filter_queryset_tabchange(currentTabState);
  }

  //Loading on API call while saving customer Addresses
  const [saveAddressLoading, setSaveAddressLoading] = useState(false)


  // the small modal that is used to add or edit a specific address
  const [editCustomerAddress, setEditCustomerAddress] = useState({ data: null, open: false, edit: false })
  const handleCustomerAddressEditOpen = (data = null, edit = false) => {
    setEditCustomerAddress({ data: data, open: true, edit: edit })
  }
  const handleCustomerAddressEditClose = () => {
    setEditCustomerAddress({ data: null, open: false, edit: false })
  }

  const saveCustomerAddress = async (id = null) => {
    var updatedCustomerData = null;
    //delete address logic
    if (id) {
      const currentData = customerAddressManagementOpen?.data;

      updatedCustomerData = currentData.customer_info?.addresses?.filter(
        element => element.id !== id
      ) || [];

      currentData.customer_info.addresses = updatedCustomerData;

      setCustomerAddressManagementOpen(prev => ({
        ...prev,
        data: {
          ...prev.data,
          customer_info: {
            ...prev.data.customer_info,
            addresses: updatedCustomerData
          }
        }
      }))

      updatedCustomerData = currentData;
    }
    else if (editCustomerAddress?.data?.name &&
      editCustomerAddress?.data?.type != 'click' &&
      editCustomerAddress?.data?.number &&
      editCustomerAddress?.data?.address) {
      //edit address logic
      if (editCustomerAddress?.edit) {
        const currentData = customerAddressManagementOpen?.data;

        updatedCustomerData = customerAddressManagementOpen?.data?.customer_info?.addresses?.map(element =>
          element.id === editCustomerAddress.data.id
            ? editCustomerAddress.data
            : element
        )

        currentData.customer_info.addresses = updatedCustomerData;

        setCustomerAddressManagementOpen(prev => ({
          ...prev,
          data: {
            ...prev.data,
            customer_info: {
              ...prev.data.customer_info,
              addresses: updatedCustomerData
            }
          }
        }))

        updatedCustomerData = currentData;


      }
      //add new address logic
      else {
        const currentData = customerAddressManagementOpen?.data

        if (!currentData) {
          console.error("No customer data found. Abort mission.")
          return
        }


        const updatedAddresses = currentData.customer_info?.addresses?.length > 0
          ? [...currentData.customer_info.addresses]
          : []

        const newId = updatedAddresses.length == 0 ? 1 : (updatedAddresses[updatedAddresses.length - 1].id + 1)

        updatedAddresses.push({
          id: newId,
          name: editCustomerAddress?.data?.name,
          type: editCustomerAddress?.data?.type,
          number: editCustomerAddress?.data?.number,
          address: editCustomerAddress?.data?.address,
          pref_time: editCustomerAddress?.data?.pref_time,
        })

        updatedCustomerData = {
          ...currentData,
          customer_info: {
            ...currentData.customer_info,
            addresses: updatedAddresses,
          },
        }

        setCustomerAddressManagementOpen(prev => ({
          ...prev,
          data: updatedCustomerData,
        }))
      }
    }
    else {
      WarningSnackbar(`Please enter mandatory values`);
    }
    //update the new data to DB after edit or add manipulation on the current one
    if (id || (editCustomerAddress?.data?.name &&
      editCustomerAddress?.data?.type != 'click' &&
      editCustomerAddress?.data?.number &&
      editCustomerAddress?.data?.address)) {
      try {
        setSaveAddressLoading(true);
        var response = await axios.post(`${API_DOMAIN}/whatsapp/update_customer_address`, { id: updatedCustomerData?.customer_info?.id, addresses: updatedCustomerData?.customer_info?.addresses })
        if (response.data.success) {
          SuccessSnackbar(`Saved address preferences successfully`);
          setquerySet(prev =>
            prev.map(element =>
              element.query_id === updatedCustomerData.query_id
                ? { ...element, customer_info: updatedCustomerData.customer_info }
                : element
            )
          );
          setEditCustomerAddress(prev => ({ ...prev, open: false }))
          filter_queryset_tabchange(currentTabState);
        }
        else {
          ErrorSnackbar(`Something went wrong while saving the address`);
        }

      } catch (error) {
        ErrorSnackbar(error.message);
      }
      finally {
        setSaveAddressLoading(false)
      }
    }
  }

  const editSpecificCustomerAddress = async (addressObj) => {
    setEditCustomerAddress({
      data: addressObj,
      open: true,
      edit: true
    });
  }

  const [selectedDeliveryAddress, setSelectedDeliveryAddress] = useState(null);
  const [createDeliveryJobLoading, setCreateDeliveryJobLoading] = useState(false);
  const [selectedDeliveryDriver, setSelectedDeliveryDriver] = useState(null)
  const [deliveryInstruction, setDeliveryInstruction] = useState(null)
  const [expectedDeliveryDate, setExpectedDeliveryDate] = useState(null)
  const [expectedDeliveryTime, setExpectedDeliveryTime] = useState(null)
  const [trackingLinkShare, setTrackingLinkShare] = useState(true)

  const createShipdayDeliveryJob = async () => {
    if (!selectedDeliveryAddress) {
      WarningSnackbar(`Please select the correct address first`);
      return;
    }
    if (!selectedDeliveryDriver) {
      WarningSnackbar(`Please select the Delivery driver`);
      return;
    }
    if (!expectedDeliveryDate || !expectedDeliveryTime) {
      WarningSnackbar(`Please set the delivery date and time`);
      return;
    }
    try {
      const payload = {
        data: customerAddressManagementOpen?.data,
        chosen_address: selectedDeliveryAddress,
        deliveryInstruction,
        trackingLinkShare,
        expectedDeliveryDate: dayjs(expectedDeliveryDate).format("YYYY-MM-DD"),
        expectedDeliveryTime: dayjs(expectedDeliveryTime).utc().format("HH:mm:ss"),
        selectedDeliveryDriver
      }

      setCreateDeliveryJobLoading(true);
      const response = await axios.post(`${API_DOMAIN}/whatsapp/create_shipday_order`, payload);

      if (response.data.success) {
        SuccessSnackbar(`Created delivery job in shipday successfully!`);
        handleCustomerAddManageClose();
        setquerySet(prev =>
          prev.map(element =>
            element.query_id === response.data.data.query_id
              ? response.data.data
              : element
          )
        );
        filter_queryset_tabchange(currentTabState, querySet.map(e => e.query_id == response.data.data.query_id ? response.data.data : e));
      }
      else {
        ErrorSnackbar(`Something went wrong while creating shipday task`);
      }
    } catch (error) {
      ErrorSnackbar(error.message);
    }
    finally {
      setCreateDeliveryJobLoading(false);
    }
  }


  const delete_wati_approval_msg_handler = (record) => {
    AntdModal.confirm({
      title: 'Reject / Delete Quote',
      content: 'Are you sure you want to reject/delete this quote?',
      okText: 'Delete',
      cancelText: 'Cancel',
      okButtonProps: { danger: true },
      onOk: async () => {
        try {
          setLoadingDeleteBtns(prev => ({ ...prev, [record?.id]: true }));
          var response = await axios.post(`${API_DOMAIN}/whatsapp/delete_wati_approval_message`, { id: record.id, admin: authState.id })
          if (response.data.success) {
            SuccessSnackbar(`Removed Approval Message Successfully!`);
            set_wati_msgs_waiting_approval(response.data.data)
          }
          else {
            ErrorSnackbar(`Something went wrong while removing the approval message`);
          }
        } catch (error) {
          ErrorSnackbar(error.message);
        }
        finally {
          setLoadingDeleteBtns(prev => ({ ...prev, [record?.id]: false }));
        }
      },
    });
  }
  const columns = [
    {
      key: "query_id",
      title: "Query ID",
      render: (value) => (
        <div key={value?.query_id}>
          {country_codes[getCountryCode(value?.phone)] != "United Arab Emirates" ?
            (<Badge.Ribbon text={
              <Tooltip title={country_codes[getCountryCode(value?.phone)] || "Unknown"} className="flex justify-between">
                <img className="mr-0.5" style={{ width: "16px" }} src={"https://cdn.clare.ai/flags/" + getCountryCode(value?.phone) + ".svg"} alt="Unknown" />
                <span>International</span>
              </Tooltip>} style={{ marginTop: "-35px", width: "110px" }}>
              <div key={value?.query_id} className="flex justify-between">
                <Tooltip className="cursor-pointer" title="Click here to copy the Query ID to clipboard." onClick={() => copyToClipboardModern(value?.query_id, "Query ID")}>
                  {value?.query_id || "Unknown"}
                </Tooltip>

                {(() => {
                  var parsedData = value?.moredetails?.success || '[]'

                  try { parsedData = JSON.parse(parsedData); } catch (error) { }

                  return value?.moredetails?.success?.length > 0 ? (
                    <div key={value?.query_id}>
                      <Tooltip title="Already sent. Click to send again.">
                        <img style={{ width: "20px", cursor: "pointer" }} src={whatsapp_logo} alt="Whatsapp_logo" />
                      </Tooltip>
                    </div>
                  ) : (
                    <div key={value?.query_id}>
                      <Tooltip title="Not sent. Click to send Now.">
                        <img style={{ width: "20px", filter: "grayscale(1)", cursor: "pointer" }} src={whatsapp_logo} alt="Whatsapp_logo" />
                      </Tooltip>
                    </div>
                  )

                })()}
              </div>
            </Badge.Ribbon>) : (<div key={value?.query_id} className="flex justify-between">
              <Tooltip className="cursor-pointer" title="Click here to copy the Query ID to clipboard." onClick={() => copyToClipboardModern(value?.query_id, "Query ID")}>
                {value?.query_id || "Unknown"}
              </Tooltip>

              {(() => {
                var parsedData = value?.moredetails?.success || '[]'

                try { parsedData = JSON.parse(parsedData); } catch (error) { }

                return value?.moredetails?.success?.length > 0 ? (
                  <div key={value?.query_id}>
                    <Tooltip title="Already sent. Click to send again.">
                      <img style={{ width: "20px", cursor: "pointer" }} src={whatsapp_logo} alt="Whatsapp_logo" />
                    </Tooltip>
                  </div>
                ) : (
                  <div key={value?.query_id}>
                    <Tooltip title="Not sent. Click to send Now.">
                      <img style={{ width: "20px", filter: "grayscale(1)", cursor: "pointer" }} src={whatsapp_logo} alt="Whatsapp_logo" />
                    </Tooltip>
                  </div>
                )

              })()}
            </div>)}

        </div>
      ),
      sorter: (a, b) => a?.query_id - b?.query_id,
      sortDirections: ["descend", "ascend"],
      width: "7%",
      fixed: "left"
      //   responsive: ["xs"]
    },
    {
      key: "timeline",
      title: "Date",
      dataIndex: "timeline",
      render: (value) => (
        <div key={value?.query_id}>
          {value && value?.length > 0 && value?.[0]?.query_created
            ? (
              <div className="gap-2">
                <div className="flex"><ClockCircleOutlined />&nbsp;{dayjs(value?.[0]?.query_created).format("DD-MM-YY hh:mm A").toString().substring(9, 17)}</div>
                <div className="flex"><CalendarOutlined />&nbsp;{dayjs(value?.[0]?.query_created).format("DD-MM-YYYY hh:mmA").toString().substring(0, 10)}</div>
              </div>
            )
            : "Timeline data not available"}
        </div>
      ),
      sorter: (a, b) => {
        const getDate = (item) =>
          item?.timeline &&
            item?.timeline.length > 0 &&
            item?.timeline?.[0]?.query_created
            ? dayjs(item?.timeline?.[0]?.query_created, "YYYY-MM-DD hh:mm:ss A").valueOf()
            : 0; // Default to 0 if date doesn't exist

        return getDate(a) - getDate(b);
      },
      width: "9%",
      sortDirections: ["descend", "ascend"],
    },
    {
      key: "user_id",
      title: "User",
      render: (value) => (
        <div key={value?.query_id}>
          {value?.user_id || "Unknown"}
        </div>
      ),
      sorter: (a, b) => a?.user_id.localeCompare(b?.user_id),
      sortDirections: ["descend", "ascend"],
      width: "10%"
    },
    {
      key: "make_model_additional_info",
      title: "Make - Model",
      render: (record) => (
        <div key={record?.query_id}>
          <div className="flex drop-shadow">
            <div style={{ width: "50px" }}>
              {carLogoTypes[record?.make?.toLowerCase()?.replaceAll(" ", "-")] ?
                (<Tooltip title={record?.make}>
                  <img style={{ width: "100%" }} src={carLogoTypes?.[record?.make?.toLowerCase()?.replaceAll(" ", "-")]?.logotype?.uri} alt={""} />
                </Tooltip>) : record?.make}
            </div>

            <div style={{ width: "100%" }}>
              <div className="border rounded p-0.5 flex" style={{ backgroundColor: "#9aede9", color: "#295754", width: "100%", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "100%", minWidth: "70px" }}>
                <div style={{ fontWeight: "600", color: "Black" }}>{record?.model?.trim() || "Not Added"}&nbsp;</div>
                {record?.year ? (<div>({record?.year?.trim()})&nbsp;</div>) : ""}
                {record?.cylinder ? (<div>({record?.cylinder?.trim()} Cylinders)&nbsp;</div>) : ""}
                {record?.region ? (<div>({record?.region?.trim()})&nbsp;</div>) : ""}
              </div>
              {/* {record.chassis_no ? (<div className="border rounded p-0.5 mt-0.5" style={{ backgroundColor: "#b0ebe8", color: "#295754" }}>{record.chassis_no}</div>) : ""}
              {record.model_details ?
                (<div className="flex align-middle">
                  <div className="border rounded p-0.5 mt-0.5" style={{ backgroundColor: "#c3e8e6", color: "#295754", width: "100%" }}>{record.model_details}</div>
                </div>
                ) : ""} */}
            </div>
          </div>
        </div >
      ),
      width: "20%"
    },
    {
      key: "body_part",
      title: "Parts",
      render: (record) => (
        <div key={record?.query_id}>
          <div style={{ maxHeight: "50px", overflowY: "auto", scrollSnapType: "y mandatory", scrollBehavior: "smooth" }}>
            {record?.body_part?.split(",")?.map((item, index) => (<div style={{ scrollSnapAlign: "start" }}>{index + 1}.&nbsp;{item}</div>)) || "Added no parts."}
          </div>
          {(<div style={{ fontSize: "11px", color: "#777" }} className="flex justify-end pr-1"><Tooltip title="Scroll inside the parts-list to see all the names.">Total :&nbsp;{record?.body_part?.split(",")?.length || 0}</Tooltip></div>)}
        </div>
      ),
      width: "15%"
    },
    {
      key: "cus_name",
      title: "Customer",
      render: (record) => (
        <div key={record?.query_id}>
          {record.moredetails?.queryOrigin?.length > 0 ? (<div style={{ fontSize: "11px", color: "#777" }} className="flex justify-between pr-1">
            <div className="cursor-pointer flex " onClick={() => handleCustomerAddManageOpen(record)} style={{ color: `${record?.customer_info?.addresses?.length > 0 ? "green" : "red"}` }}>
              <Tooltip title="Manage delivery Addresses and timings of the customer"><HomeFilled /></Tooltip>
            </div>
            {record.moredetails?.shipdayOrders?.length > 0 ? (<span>
              {/* {record.moredetails?.shipdayOrders.map(e => e.orderStatus?.orderState == )} */}
              <Tooltip title="Click here to manage the delivery jobs">
                <img className="shaky-truck cursor-pointer" style={{ width: "17px" }} src={truck_delivery} />
              </Tooltip>
            </span>) : null}
            <div>{record.moredetails?.queryOrigin?.[0]?.label}</div>
          </div>) : ""}
          < div className="border rounded p-1" style={{ fontWeight: "550", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "180px", minWidth: "90px" }}>
            {record?.cus_name ? record?.cus_name : <i>Name Unknown</i>}
          </div >
          <div className="border rounded p-1 mt-0.5 flex justify-between" style={{ maxWidth: "180px", minWidth: "90px" }}>
            <div className="flex" style={{ overflowX: "auto" }}>
              <Tooltip title={country_codes[getCountryCode(record?.phone)] || "Unknown"}>
                <img style={{ width: "15px" }} src={"https://cdn.clare.ai/flags/" + getCountryCode(record?.phone) + ".svg"} alt="Unknown" />
              </Tooltip>
              &nbsp;
              <div>{record?.phone ? (<div className="cursor-pointer" onClick={() => copyToClipboardModern(record?.phone, "Number")}><Tooltip title="Click here to copy the number to clipboard.">{record?.phone}</Tooltip></div>) : <i>Number Unknown</i>}</div>
            </div>
            <div className="flex items-center justify-center cursor-pointer">
              <Tooltip title="Go to the WATI chat">
                <img id={`wati_chat_button_${record?.query_id}`} onClick={() => open_wati_chat(`wati_chat_button_${record?.query_id}`, record?.phone)} style={{ width: "15px" }} src={wati_logo_only} />
              </Tooltip>
            </div>
          </div>
        </div >
      ),
      sorter: (a, b) => a?.moredetails?.queryOrigin?.[0]?.label.localeCompare(b?.moredetails?.queryOrigin?.[0]?.label),
      sortDirections: ["descend", "ascend"],
      width: "12%"
    },
    {
      key: "status",
      title: "Current Status",
      render: (record) => (
        <div key={record?.query_id}>
          {record?.status}
        </div >
      ),
      sorter: (a, b) => a?.status?.localeCompare(b?.status),
      width: "13%"
    },
    {
      key: "price_given",
      title: "SP",
      dataIndex: "price_given",
      sorter: (a, b) => a?.price_given - b?.price_given,
      sortDirections: ["descend", "ascend"],
      width: "6%",
    },
    {
      key: "moredetails",
      title: "Actions",
      render: (record) => (
        <div key={record?.query_id}>
          <div className="flex justify-center">
            <div className="gap-2" style={{ fontSize: "18px", width: "20px" }}>

              <Tooltip placement="left" title="Edit and save or save & send this query.">
                <EditOutlined className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => handleQueryEdit(record)} />
              </Tooltip>

              <Tooltip placement="left" title="Duplicate this query and make a new one.">
                <RetweetOutlined className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => handleQueryDuplicate(record)} />
              </Tooltip>

              <Tooltip placement="left" title="Delete this query">
                <DeleteOutlined style={{ color: "#ff7c73" }} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => handleRowsDelete(record?.query_id)} />
              </Tooltip>

            </div>
          </div>
        </div>
      ),
      width: "4%"
    },
  ];
  const columns_wati_approval_table = [
    {
      key: "id",
      render: (record) => (
        <div key={record?.query_id}>
          <div className="flex items-center">
            {!record?.admin ? (
              <div style={{
                width: "5px",
                height: "5px",
                backgroundColor: "red",
                borderRadius: "5px"
              }} />
            ) : null}
            &nbsp;
            {record?.id}
          </div>
        </div>
      ),
      title: "Row ID",
      width: "8%"
    },
    {
      key: "query_id",
      dataIndex: "query_id",
      title: "Query ID",
      width: "9%"
    },
    {
      key: "user_name",
      dataIndex: "user_name",
      title: "User",
    },
    {
      title: "Reply Template",
      render: (record) => (
        <div key={record?.query_id}>
          <div className="border rounded p-2" style={{ height: "120px", overflowY: "auto" }}>{record?.msg_text}</div>
        </div>
      ),
    },
    {
      title: "Req Time",
      render: (value) => (
        <div key={value?.query_id}>
          {dayjs(value?.req_time).format("YYYY-MM-DD hh:mm:ss A")}
        </div>
      ),
    },
    {
      title: "Approved",
      render: (record) => (
        <div key={record?.query_id}>
          {record?.admin_name ? record?.admin_name : "Not Approved by anyone"}
        </div>
      ),
    },
    {
      title: "Approved Time",
      render: (record) => (
        <div key={record?.query_id}>
          {record?.approve_time ? dayjs(record?.approve_time).format("YYYY-MM-DD hh:mm:ss A") : "Yet to be approved"}
        </div>
      ),
    },
    {
      title: "Actions",
      render: (record) => (
        <div key={record?.query_id}>
          <div className="flex justify-center">
            {record?.admin_name ? (<Tooltip title="Already Approved, No action needed.">
              <CheckCircleOutlined style={{ color: "green" }} />
            </Tooltip>) : (<div>
              <div>
                <Button
                  loading={loadingBtns[record?.id]}
                  shape="circle" style={{ backgroundColor: "green" }} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" onClick={() => {
                    pre_wati_approval_msg_handler(record);
                  }} icon={<SendOutlined style={{ color: "white" }} />} /></div><br />
              <div>
                {(
                  <Button
                    loading={loadingDeleteBtns[record?.id]}
                    onClick={() => {
                      delete_wati_approval_msg_handler(record)
                    }} className="cursor-pointer hover:scale-125 active:scale-90 transition-transform duration-100 ease-in-out" shape="circle" icon={<DeleteOutlined style={{ color: "#ff6b6b" }} />} />
                )}
              </div></div>)}

          </div>
        </div>
      ),
    },
  ]
  const tabItems = [
    {
      key: 'All',
      label: 'All',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.length} color="blue" status="progress" />
    },
    {
      key: 'Waiting for Price',
      label: 'Waiting for Price',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Waiting for Price')?.length} color="grey" status="default" />
    },
    {
      key: 'Waiting for confirmation',
      label: 'Waiting for confirmation',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Waiting for confirmation')?.length} color="yellow" status="warning" />
    },
    {
      key: 'Confirmed,Confirmed & Paid',
      label: 'Confirmed',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Confirmed' || element?.status == 'Confirmed & Paid')?.length || 0} color="green" status="success" />
    },
    {
      key: 'Cancelled,Customer Declined,Unavailable,Query Lost,Other',
      label: 'Lost',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Cancelled' || element?.status == 'Customer Declined' || element?.status == 'Unavailable' || element?.status == 'Query Lost' || element?.status == 'Other')?.length || 0} color="red" status="error" />
    },
    {
      key: 'Out for delivery',
      label: 'Out for Delivery',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Out for delivery')?.length || 0} color="orange" status="warning" />
    },
    {
      key: 'Delivered',
      label: 'Delivered',
      icon: <Badge overflowCount={9999999999} showZero count={querySet?.filter(element => element?.status == 'Delivered')?.length || 0} color="green" status="success" />
    },
    {
      key: 'Postponed_to_today',
      label: 'Postponed to Today',
      icon: <Badge style={{ backgroundColor: "#bf6000" }} overflowCount={9999999999} showZero count={postponedQuerySet?.filter((element) => element?.status?.includes("Today")).length || 0} color="red" status="error" />
    },
    {
      key: 'whatsapp_unsent',
      label: 'WhatsApp Unsent',
      icon: <Badge style={{ backgroundColor: "#0b6b00" }} overflowCount={9999999999} showZero count={querySet?.filter((element) => !(element?.moredetails?.success)).length || 0} color="red" status="error" />
    },
  ];

  const onTabChange = (e) => {
    scrollToExtreme("up");
    setCurrentTabState(e);
    setLoading(true);
    filter_queryset_tabchange(e);
  }
  const filter_queryset_tabchange = (e, updatedQuerySet = querySet) => {
    const items = e.split(",");
    if (items.includes("All")) {
      setquerySetTable(updatedQuerySet);
      setLoading(false);
    } else if (items.includes("Postponed_to_today")) {
      setquerySetTable(postponedQuerySet); // Assuming postponedQuerySet is already filtered correctly
      setLoading(false);
    } else if (items.includes("whatsapp_unsent")) {
      setquerySetTable(updatedQuerySet?.filter((element) => !(element?.moredetails?.success)));
      setLoading(false);
    } else {
      setquerySetTable(updatedQuerySet.filter(element => items.includes(element.status)));
      setLoading(false);
    }
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const hover_menu_items = [
    {
      key: '1',
      label: 'Qoute End-User',
    },
    {
      key: '2',
      label: 'Qoute Garage',
    },
    {
      key: '3',
      label: 'Follow-up',
    }
  ];
  const generateAccordionItems = (record) => {
    return [
      {
        key: '1',
        label: 'Query Reply Timeline',
        children: <div className="border rounded p-1 overflow-y-auto" style={{ height: "150px", overflowY: "auto", width: "100%" }}>
          {record?.timeline ? (
            <><div className="flex justify-end mb-2" style={{ position: "sticky", top: -6, backgroundColor: "white", zIndex: 10 }}>
              <div className="pl-2 pr-2" style={{ fontSize: "10px" }}>
                {record?.timeline ? "Time Spent : " + calculateTimeDifference(record?.timeline) : ""}
              </div>
            </div>
              <Timeline
                className="pl-2"
                mode="left"
                items={formatTimeline(record?.timeline).reverse()}
              /></>) : "No Timeline Data Available!"}

        </div>,
      },
      {
        key: '2',
        label: 'Bot Information',
        children:
          <div className="border rounded p-1 overflow-y-auto" style={{ height: "150px", overflowY: "auto", width: "100%" }}>
            <div className="flex justify-between mb-2" style={{ position: "sticky", top: -6, backgroundColor: "white", zIndex: 10, fontSize: "10px" }}>
              <div style={{ width: "260px", overflowY: "auto" }}>Sup Grps :&nbsp;<b>{(() => {
                var parsedData = record?.sup_set || '[]'
                try { parsedData = JSON.parse(parsedData); } catch (error) { }

                if (!(parsedData?.length)) return null;

                return parsedData ? parsedData.map((e) => {
                  return (e.label);
                }).join(", ") : null
              })()}</b>
              </div>
              <div className="pr-2" style={{ fontSize: "10px" }}>
                Total Suppliers :&nbsp;
                <b>
                  {(() => {
                    var parsedData = record?.moredetails?.success || '[]'
                    try { parsedData = JSON.parse(parsedData); } catch (error) { }

                    if (parsedData?.length)
                      return (parsedData?.length)
                    else
                      return (`No data available`)
                  })()}
                </b>
              </div>
            </div>
            <div className="pl-2">
              {(() => {
                var parsedData = record?.moredetails?.success || '[]'
                try { parsedData = JSON.parse(parsedData); } catch (error) { }

                if (parsedData?.length) {

                  const sortedData = parsedData.sort((a, b) => {
                    const isUzdPartA = supplierSet.find(f => f?.number === (a?.phoneNumber?.replace("@c.us", "") || a?.replace("@c.us", "")))?.name?.toLowerCase().includes("uzdpart") ? 1 : 0;
                    const isUzdPartB = supplierSet.find(f => f?.number === (b?.phoneNumber?.replace("@c.us", "") || b?.replace("@c.us", "")))?.name?.toLowerCase().includes("uzdpart") ? 1 : 0;

                    return isUzdPartA - isUzdPartB;  // Move uzdpart entries to the end
                  });

                  return sortedData.map((e, index) => {
                    const supplierName =
                      supplierSet.find(f => f?.number === (e?.phoneNumber?.replace("@c.us", "") || e?.replace("@c.us", "")))?.name || "Unknown Supplier, Probably removed";

                    return (
                      <div key={index}>
                        {supplierName?.toLowerCase().includes("uzdpart") ? (
                          <i style={{ color: "gray", fontWeight: "400" }}>
                            {index + 1}.&nbsp;
                            <Tooltip className="cursor-pointer" title="Click here to copy the Supplier Number to clipboard." onClick={() => copyToClipboardModern(e?.phoneNumber?.replace("@c.us", "") || e.replace("@c.us", ""), "Supplier Phone number")}>
                              <u>{e?.phoneNumber?.replace("@c.us", "") || e?.replace("@c.us", "")}</u>
                            </Tooltip>&nbsp;({supplierName})
                          </i>
                        ) : (
                          <div>
                            {index + 1}.&nbsp;
                            <Tooltip className="cursor-pointer" title="Click here to copy the Supplier Number to clipboard." onClick={() => copyToClipboardModern(e?.phoneNumber?.replace("@c.us", "") || e?.replace("@c.us", ""), "Supplier Phone number")}>
                              <u>{e?.phoneNumber?.replace("@c.us", "") || e?.replace("@c.us", "")}</u>
                            </Tooltip>&nbsp;({supplierName})
                          </div>
                        )}
                      </div>
                    );
                  });
                }

                else
                  return null;

              })()}
            </div>

          </div>
      },
      {
        key: '3',
        label: 'Whatsapp Chats',
        children: <QueryChatMini record={record} supplierSet={supplierSet} />,
      }
    ]
  }
  const onMenuClick = async (e, data) => {
    //loading all templates for once
    const templates = await loadAllTemplates();
    //setting templates and record data
    setAllTemplateData({
      record: data,
      templates: templates,
      templates_temp: templates,
    })

    //it will check which template is selected and set that template data along with setting the modal opening trigger to true
    switch (e.key) {
      case '1':
        //price new end-user
        var chosenTemplateOut = templates?.find(e => e?.id == "66a88464ce5c8cc0f7931371")?.text;
        setAllTemplateData(prev => ({
          ...prev,
          chosenTemplateID: "66a88464ce5c8cc0f7931371",
          finalViewOpen: true,
          msg_text: null,
          moredetails: null,
          chosenTemplateOut: chosenTemplateOut
        }))

        break;
      case '2':
        //price new garage
        var chosenTemplateOut = templates?.find(e => e?.id == "66bb35936e50becccc4d0b56")?.text;
        setAllTemplateData(prev => ({
          ...prev,
          chosenTemplateID: "66bb35936e50becccc4d0b56",
          finalViewOpen: true,
          msg_text: null,
          moredetails: null,
          chosenTemplateOut: chosenTemplateOut
        }))
        break;
      case '3':
        //follow-up
        var chosenTemplateOut = templates?.find(e => e?.id == "6755a194c5777fabc9b6e791")?.text;
        setAllTemplateData(prev => ({
          ...prev,
          chosenTemplateID: "6755a194c5777fabc9b6e791",
          finalViewOpen: true,
          msg_text: null,
          moredetails: null,
          chosenTemplateOut: chosenTemplateOut
        }))
        break;
      default:
        AntdModal.warning({ title: 'Invalid Selection', content: 'Invalid selection!' })
        break;
    }
  };
  const calculateTimeDifference = (timeline) => {
    if (timeline.length < 2) return 'Not enough data';

    const firstTime = new Date(Object.values(timeline[0])[0]);
    const lastTime = new Date(Object.values(timeline[timeline.length - 1])[0]);

    const diffInSeconds = Math.abs((lastTime - firstTime) / 1000);
    const minutes = Math.floor(diffInSeconds / 60);
    const seconds = Math.floor(diffInSeconds % 60);

    return `${minutes} minutes ${seconds} seconds`;
  }
  const formatTimeline = (timeline) => {
    return timeline.map(item => {
      const key = Object.keys(item)[0];
      const value = item[key];
      return {
        children: `${key.replace(/_/g, ' ')} ${value}`
      };
    });
  }
  const buildTimeline = (type, extra = '') => {
    const dt = dayjs().format('YYYY-MM-DD hh:mm:ss A');
    const name = authState.user?.name || 'Unknown';
    switch (type) {
      case 'status': return { [`status_changed (${extra}) - by ${name}`]: dt };
      case 'remarks': return { [`remarks_added - by ${name}`]: dt };
      case 'f_date': return { [`followup_date_added - by ${name}`]: dt };
      case 'warranty': return { [`warranty_added - by ${name}`]: dt };
      case 'supplier_price': return { [`supplier_and_pricing_updated - by ${name}`]: dt };
      case 'disable': return { [`disabled_by ${name}`]: dt };
      default: return { [`updated - by ${name}`]: dt };
    }
  };

  const buildMiscTimeline = (query_id, updates) => {
    const existing = queryDataMap[query_id] || {};
    const existingMoredetails = existing.moredetails || {};
    const entries = [];

    if (updates.status && updates.status !== existing.status) {
      entries.push(buildTimeline('status', updates.status));
    }
    if (updates.remarks !== undefined && updates.remarks !== existingMoredetails.remarks) {
      entries.push(buildTimeline('remarks'));
    }
    if (updates.f_date !== undefined && updates.f_date !== existingMoredetails.f_date) {
      entries.push(buildTimeline('f_date'));
    }
    if (updates.warranty !== undefined && updates.warranty !== existingMoredetails.warranty) {
      entries.push(buildTimeline('warranty'));
    }
    return entries;
  };
  const [openCustomerAddModal, setOpenCustomerAddModal] = useState(false);
  const handleOpenCustomerAddModal = () => {
    setOpenCustomerAddModal(true);
  }
  const handleCloseCustomerAddModal = () => {
    setOpenCustomerAddModal(false);
  }

  const flashRowWithPagination = (rowKey, color = "#ffd700", flashDuration = 1000) => {
    // Access the Ant Design table element
    const tableElement = document.querySelector(".ant-table");

    if (!tableElement) {
      console.warn("Table not found!");
      return;
    }

    // Step 1: Check if the row is already in the current page
    let rowElement = document.querySelector(`.ant-table-row[data-row-key="${rowKey}"]`);

    if (rowElement) {
      // If row is found, flash it
      flashRow(rowKey, color, flashDuration);
      return;
    }

    // Step 2: If row is not found, we assume it's on another page.
    // Find the pagination buttons
    const pagination = document.querySelector(".ant-pagination");
    if (!pagination) {
      console.warn("Pagination not found!");
      return;
    }

    const totalPages = document.querySelectorAll(".ant-pagination-item").length;

    let currentPage = 1;

    const goToNextPage = () => {
      const nextPageButton = document.querySelector(".ant-pagination-next");
      if (nextPageButton && !nextPageButton.classList.contains("ant-pagination-disabled")) {
        nextPageButton.click();
        setTimeout(checkForRow, 300);  // Allow time for the page to load
      } else {
        console.warn(`Row with key "${rowKey}" not found on any page.`);
      }
    };

    const checkForRow = () => {
      rowElement = document.querySelector(`.ant-table-row[data-row-key="${rowKey}"]`);
      if (rowElement) {
        // Row found, flash it
        flashRow(rowKey, color, flashDuration);
      } else if (currentPage < totalPages) {
        currentPage++;
        goToNextPage();
      } else {
        console.warn(`Row with key "${rowKey}" not found!`);
      }
    };

    // Start checking pages
    checkForRow();
  };
  // Helper function to flash row (already created)
  const flashRow = (rowKey, color, flashDuration) => {
    const rowElement = document.querySelector(`.ant-table-row[data-row-key="${rowKey}"]`);
    if (rowElement) {
      rowElement.scrollIntoView({ behavior: "smooth", block: "center" });

      const originalColor = rowElement.style.backgroundColor;
      const animationDuration = flashDuration / 8;
      rowElement.style.transition = `background-color ${animationDuration}ms ease-in-out`;

      let flashCount = 0;
      const flashEffect = setInterval(() => {
        if (flashCount >= 6) {
          clearInterval(flashEffect);
          rowElement.style.backgroundColor = originalColor;
          rowElement.style.transition = "";
        } else {
          rowElement.style.backgroundColor = flashCount % 2 === 0 ? color : originalColor;
          flashCount++;
        }
      }, flashDuration / 3);
    }
  };

  const [watiBulkMessageCombo, setWatiBulkMessageCombo] = useState({ data: null, open: false })

  const handleWatiBulkMessageComboOpen = () => {
    setWatiBulkMessageCombo({ data: querySet?.filter(element => element?.status == 'Waiting for confirmation')?.reverse(), open: true })
  }
  const handleWatiBulkMessageComboClose = () => {
    setWatiBulkMessageCombo({ data: null, open: false })
  }
  //check all for wati bulk message send selection controllers
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [sendLoadingWatiBulk, setSendLoadingWatiBulk] = useState(false);
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const send_wati_bulk_messages = async () => {
    setSendLoadingWatiBulk(true)
    try {
      const response = await axios.post(API_DOMAIN + "/whatsapp/send_wati_bulk_reminder", { query_id: selectedRowKeys, admin: authState.id, followupChoice, followup_id });
      if (response?.data?.success) {
        SuccessSnackbar("Messages sent successfully!");
        setSelectedRowKeys([]);
        handleWatiBulkMessageComboClose();
        reloadQuerySet();
      } else {
        ErrorSnackbar(`Failed to send messages`);
      }
    } catch (error) {
      ErrorSnackbar(error.message);
    }
    finally {
      setSendLoadingWatiBulk(false)
    }
  }

  const get_price_given_time = (record) => {
    const statusChangeEntry = record.timeline.find(
      (item) => Object.keys(item)[0].includes('status_changed (Waiting for confirmation)')
    );
    return statusChangeEntry ? Object.values(statusChangeEntry)[0].split(' - ')[0].trim() : null;
  }

  const formatDuration = (start, end) => {

    if (start && end) {
      const diffInMinutes = end.diff(start, 'minute');

      const d = Math.floor(diffInMinutes / (60 * 24));
      const h = Math.floor((diffInMinutes % (60 * 24)) / 60);
      const m = diffInMinutes % 60;

      const parts = [];
      if (d) parts.push(`${d}d`);
      if (h) parts.push(`${h}h`);
      if (m || parts.length === 0) parts.push(`${m}m`);

      return parts.join(' ');
    }
    else {
      return `Unknown time`;
    }
  };

  const [followupChoice, setFollowupChoice] = useState('bot');
  const onFollowupChange = e => {
    setFollowupChoice(e.target.value);
  };
  const [followup_id, setFollowup_id] = useState(null);
  const onFollowupIdChange = value => {
    setFollowup_id(value);
  };

  //states for confirm shipment last modal view
  const [all_data_confirm_shipment, set_all_data_confirm_shipment] = useState();

  return (
    <>
      <div
        style={{
          width: '100%',
          background: 'white',
          borderRadius: '10px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
          overflow: 'hidden',
          border: '1px solid #e5e7eb',
          position: 'sticky',
          top: 70,
          zIndex: 1000,
        }}
      >
        {/* Panel header */}
        <div
          className="flex items-center justify-between px-4 py-2"
          style={{ background: 'linear-gradient(90deg, #1d4ed8 0%, #3b82f6 60%, #64aafa 100%)' }}
        >
          <div className="flex items-center gap-2">
            <FilterOutlined style={{ color: 'white', fontSize: 15 }} />
            <span style={{ color: 'white', fontWeight: 700, fontSize: 14, letterSpacing: '0.04em' }}>Queryset V3</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Tooltip title={`${add_query_btn_disabled ? bot_status : "Add new Query"}`}>
              <Button
                size="small"
                disabled={add_query_btn_disabled}
                loading={add_query_btn_loading}
                ghost
                type="primary"
                onClick={handleOpen}
                style={{ borderColor: 'rgba(255,255,255,0.6)', color: 'white' }}
              >
                <PlusSquareOutlined /> New Query
              </Button>
            </Tooltip>
            {authState?.user?.wati_msg_approval ? (
              <Tooltip title="List of WATI message requests">
                <Badge style={{ fontSize: '10px' }} count={(wati_msgs_waiting_approval.filter(e => e.admin == null))?.length || 0}>
                  <Button
                    size="small"
                    ghost
                    type="primary"
                    disabled={!authState?.user?.admin}
                    onClick={handleOpenWatiApproval}
                    style={{
                      borderColor: 'rgba(255,255,255,0.6)',
                      color: 'white',
                      animation: (wati_msgs_waiting_approval.filter(e => e.admin == null))?.length > 0 ? 'shake 0.5s infinite alternate, scaleUp 0.5s infinite alternate' : 'none',
                    }}
                  >
                    <BellOutlined style={{ fontSize: 15 }} />
                  </Button>
                </Badge>
              </Tooltip>
            ) : null}
            {authState?.user?.wati_msg_approval ? (
              <Tooltip title="Send Bulk WATI Messages">
                <Button size="small" ghost type="primary" disabled={loading} onClick={handleWatiBulkMessageComboOpen} style={{ borderColor: 'rgba(255,255,255,0.6)', color: 'white' }}>
                  <MailOutlined />
                </Button>
              </Tooltip>
            ) : null}
            {authState?.user?.wati_msg_approval ? (
              <Tooltip title="Open settings">
                <Button size="small" ghost type="primary" onClick={handleOpenSettingsModal} style={{ borderColor: 'rgba(255,255,255,0.6)', color: 'white' }}>
                  <SettingOutlined />
                </Button>
              </Tooltip>
            ) : null}
          </div>
        </div>

        {/* Inputs body */}
        <div className="px-4 py-3" style={{ background: '#f8fafc' }}>
          <div className="flex flex-wrap gap-4 items-end">
            <div>
              <span style={{ fontSize: '11px', fontWeight: 600, color: '#4b5563', marginBottom: '3px', display: 'block', letterSpacing: '0.03em' }}>
                <SearchOutlined style={{ marginRight: 4 }} />Search Term
              </span>
              <AntdInput
                style={{ width: '225px' }}
                allowClear
                placeholder="Customer, query ID..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(event) => { if (event.key === 'Enter') { reloadQuerySet(); } }}
              />
            </div>

            <div>
              <span style={{ fontSize: '11px', fontWeight: 600, color: '#4b5563', marginBottom: '3px', display: 'block', letterSpacing: '0.03em' }}>
                <CalendarOutlined style={{ marginRight: 4 }} />Date Range
              </span>
              <RangePicker style={{ width: '225px' }} presets={rangePresets} value={[startDate, endDate]} onChange={onSearchDateChange} maxDate={dayjs()} />
            </div>

            {authState?.user.admin ? (
              <div>
                <span style={{ fontSize: '11px', fontWeight: 600, color: '#4b5563', marginBottom: '3px', display: 'block', letterSpacing: '0.03em' }}>
                  <UserOutlined style={{ marginRight: 4 }} />Users
                </span>
                <Select
                  mode="multiple"
                  allowClear
                  style={{ minWidth: '160px', maxWidth: '225px' }}
                  optionFilterProp="label"
                  id="search_select"
                  placeholder="Select Users"
                  value={searchUser}
                  onChange={(e) => setSearchUser(e)}
                  options={usersSet}
                />
              </div>
            ) : null}

            <div className="flex gap-2 ml-auto">
              <Tooltip title="Download as PDF">
                <Button id="pdf_button" disabled={isDownloadButtonDisabled} onClick={() => handlePdfClick()}>
                  <FilePdfOutlined /><DownloadOutlined />
                </Button>
              </Tooltip>
              <Tooltip title="Download as Excel">
                <Button id="excel_button" disabled={isDownloadButtonDisabled} onClick={() => handleExcelClick()}>
                  <FileExcelOutlined /><DownloadOutlined />
                </Button>
              </Tooltip>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={reloadQuerySet}
                style={{ background: 'linear-gradient(90deg, #1d4ed8, #3b82f6)', border: 'none', fontWeight: 600, paddingInline: '20px' }}
              >
                Search
              </Button>
            </div>
          </div>
        </div>
      </div>

      <br />
      <div>
        <div className="mb-2 border rounded pt-2 pb-2 flex justify-between pr-10 pl-10" style={{ marginTop: "-11px", backgroundColor: "#7fd49d" }}>

          <div className="flex items-center gap-1 border drop-shadow-1 rounded pr-2 pl-2 pt-0.5 pb-0.5" style={{ color: "black", backgroundColor: "white" }}>
            <Badge
              overflowCount={9999999999}
              count={querySetTable.filter(e => !String(e.phone).startsWith("971")).length}
              showZero
              color="green"
            />
            International Queries
          </div>

          <div className="flex items-center gap-1 border drop-shadow-1 rounded pr-2 pl-2 pt-0.5 pb-0.5" style={{ color: "black", backgroundColor: "white" }}>
            <Badge
              overflowCount={9999999999}
              count={querySetTable.filter(e => String(e.phone).startsWith("971")).length}
              showZero
              color="green"
            />
            Local Queries
          </div>


          <div className="flex items-center gap-1 border drop-shadow-1 rounded pr-2 pl-2 pt-0.5 pb-0.5" style={{ color: "black", backgroundColor: "white" }}>
            <Badge overflowCount={9999999999} count={querySetTable.reduce((sum, e) => sum + (Number(e.price_given) || 0), 0)} showZero color="green" />
            Total SP
          </div>

        </div>
      </div>
      <div>
        <div className="flex justify-center border rounded" style={{ position: "sticky", top: 125, zIndex: "1000", backgroundColor: "white" }}>
          <Tabs id="main_tabs" style={{ width: "98%", marginBottom: "-16px" }} defaultActiveKey="1" items={tabItems} onChange={onTabChange} animated />
        </div>
        <Table
          rowKey={(record) => record.query_id}
          dataSource={querySetTable}
          className="drop-shadow border rounded"
          style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important" }}
          columns={columns}
          loading={loading}
          bordered={true}
          pagination={{
            position: ["topRight", "bottomRight"],
          }}

          expandable={{
            expandIcon: ({ expanded, onExpand, record }) =>
              expanded ? (
                <MinusCircleTwoTone className="scale-150" onClick={e => onExpand(record, e)} />
              ) : (
                <PlusCircleTwoTone className="scale-150" onClick={e => onExpand(record, e)} />
              ),
            expandedRowRender: (record) => (
              <div className="flex gap-2">
                <div>
                  {record?.chassis_no ? (<div className="border rounded drop-shadow flex justify-center ml-4 mt-3 cursor-pointer" style={{ width: "200px", backgroundColor: "#f7f7f7" }} onClick={() => copyToClipboardModern(record?.chassis_no, "VIN")}>
                    <Tooltip title="Click here to copy the VIN to clipboard">
                      VIN :&nbsp;{record?.chassis_no}
                    </Tooltip>
                  </div>) : (<div className="border rounded drop-shadow flex justify-center ml-4 mt-3 align-middle" style={{ width: "200px" }} >
                    VIN :&nbsp;<i style={{ color: "gray" }}>NOT ADDED</i>
                  </div>)}
                  <div className="image-slider-container drop-shadow m-3" style={{ width: "200px" }}>
                    <Slider {...settings} >
                      {record.image.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            width: "200px",
                            height: "200px",
                            overflow: "hidden",
                            position: "relative"
                          }}
                        >
                          <Image
                            style={{
                              width: "200px",
                              height: "200px",
                              border: "2px solid rgb(206, 203, 203)",
                              borderRadius: "8px",
                              objectFit: "contain"
                            }}
                            src={API_DOMAIN + "/" + item}
                            alt={`${API_DOMAIN}/images/no_img.jpg`}
                            loading="lazy" />
                        </div>
                      ))}
                    </Slider>
                  </div>
                </div>
                <Divider style={{ height: "auto" }} type="vertical" />

                <div className="m-3 drop-shadow" style={{ maxWidth: "300px", minWidth: "200px" }}>
                  <div style={{ backgroundColor: "#f7f7f7", borderRadius: "8px" }} className="p-1.5 drop-shadow">
                    <div>
                      <Select
                        showSearch
                        size="small"
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Select a Supplier"
                        options={supplierSet.map((item) => (
                          { value: item?.id, label: item?.name, number: item?.number }))}
                        value={priceValues?.[record?.query_id]?.supplier ? parseInt(priceValues?.[record?.query_id]?.supplier) : null}
                        onChange={(e) => handlePriceValueChanges(record?.query_id, 'supplier', e)}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0 ||
                          String(option?.value)?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0 ||
                          String(option?.number)?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                        }
                      >
                      </Select>
                    </div>
                    <div className="pt-1 pl-1" style={{ fontSize: "10px", fontWeight: "540" }}>
                      Pricing Details
                    </div>
                    <div className="border drop-shadow rounded p-1" style={{ backgroundColor: "#fbfbfb" }}>
                      <div>
                        <div style={{ fontSize: "10px" }}>BPrice</div>
                        <InputNumber
                          style={{ width: "100%" }}
                          addonBefore={"AED"}
                          size="small"
                          formatter={value => `${value}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={value => value?.replace(/\$\s?|(,*)/g, '')}
                          onChange={(e) => handleBestPriceChange(record?.query_id, e)}
                          value={priceValues[record?.query_id]?.["best_price_received"] || 0}
                          placeholder="Buying Price"
                        />
                      </div>
                      <div >
                        <Divider className="mt-1.5 mb-1.5" style={{ backgroundColor: "black" }} />
                      </div>
                      <div>
                        <div style={{ fontSize: "10px" }}>Margin Percentage</div>
                        <InputNumber
                          style={{ width: "100%" }}
                          size="small"
                          addonBefore={priceValues?.[record?.query_id]?.["price_percentage"] == 0 ? <ImportExport /> : priceValues[record?.query_id]?.["price_percentage"] > 0 ? <ArrowUpwardIcon style={{ color: "green" }} /> : <ArrowDownwardIcon style={{ color: "red" }} />}
                          addonAfter={"%"}
                          formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={value => value?.replace(/\$\s?|(,*)/g, '')}
                          onChange={(e) => handlePercentageChange(record?.query_id, e)}
                          value={priceValues?.[record?.query_id]?.["price_percentage"]}
                          placeholder="Margin Percentage"
                        />
                      </div>
                      <div>
                        <div style={{ fontSize: "10px" }}>Delivery Charge</div>
                        <InputNumber
                          style={{ width: "100%" }}
                          size="small"
                          addonBefore={<LocalShippingIcon />}
                          formatter={value => `${value}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                          parser={value => value?.replace(/\$\s?|(,*)/g, '')}
                          onChange={(e) => handleDeliverycostChange(record?.query_id, e)}
                          value={priceValues[record?.query_id]?.["delivery_cost"]?.["DeliveryCost"]}
                          placeholder="Delivery Cost"
                        />
                      </div>
                      <div>
                        <Divider className="mt-1.5 mb-1.5" style={{ backgroundColor: "black", }} />
                      </div>
                      <div>
                        <div style={{ fontSize: "10px" }}>Final Price</div>
                        <InputNumber
                          id={"price_given" + record?.query_id}
                          style={{ width: "100%", fontWeight: "700" }}
                          size="small"
                          addonBefore={<SellIcon />}
                          onChange={(e) => handleGivenPriceChange(record?.query_id, e)}
                          value={priceValues?.[record?.query_id]?.["price_given"]}
                          placeholder="Price Given"
                        />
                      </div>
                    </div>
                    <div className="mt-1.5">
                      <Button size="small" type="primary" block loading={!!supplierPriceLoading[record?.query_id]} onClick={() => handleSupplierPriceUpdate(record?.query_id)}>Update</Button>
                    </div>
                  </div>
                </div>

                <Divider style={{ height: "auto" }} type="vertical" />

                <div className="m-3 drop-shadow">
                  <div style={{ backgroundColor: "#f7f7f7", borderRadius: "8px" }} className="p-1.5 drop-shadow">
                    <div>
                      <div className="pl-1" style={{ fontSize: "10px", fontWeight: "540" }}>
                        Miscellaneous Data
                      </div>

                      <div className="rounded">

                        <div style={{ backgroundColor: "#fbfbfb" }} className="drop-shadow border rounded p-1">
                          <div>
                            <div style={{ fontSize: "10px" }}>Query Status</div>
                            <Select
                              showSearch
                              id="status_value"
                              size="small"
                              style={{ width: "209px" }}
                              placeholder="Select a Status"
                              optionFilterProp=""
                              value={priceValues?.[record?.query_id]?.["status"]}
                              onChange={(e) => handlePriceValueChanges(record?.query_id, 'status', queryStatusSet?.find(el => el?.value == e)?.label)}
                              options={queryStatusSet}
                              filterOption={(input, option) =>
                                option?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0 ||
                                String(option?.value)?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                              }
                            />
                          </div>
                        </div>

                        <div style={{ backgroundColor: "#fbfbfb" }} className="border drop-shadow rounded p-1 mt-2.5">
                          <div>
                            <div style={{ fontSize: "10px" }}>Remarks</div>
                            <AntdInput
                              allowClear
                              size="small"
                              style={{ width: "209px" }}
                              placeholder="Add a Remark"
                              optionFilterProp="children"
                              value={priceValues?.[record?.query_id]?.["remarks"] || null}
                              onChange={(e) => handleRemarksChange(record?.query_id, e.target.value)}
                            >
                            </AntdInput>
                          </div>
                          <div>
                            <div style={{ fontSize: "10px" }}>Follow-up Date</div>
                            <DatePicker
                              size="small"
                              value={priceValues?.[record?.query_id]?.["f_date"]}
                              onChange={(e) => handle_f_date_Change(record?.query_id, e)}
                              format={'YYYY-MM-DD'}
                              style={{ width: "209px" }}
                            />
                          </div>
                        </div>

                        <div style={{ backgroundColor: "#fbfbfb" }} className="border drop-shadow rounded p-1 mt-2.5">
                          <div>
                            <div style={{ fontSize: "10px" }}>Warranty</div>
                            <InputNumber
                              style={{ width: "209px" }}
                              size="small"
                              addonAfter={"Days"}
                              onChange={(e) => handleWarrantyChange(record?.query_id, e)}
                              value={priceValues?.[record?.query_id]?.["warranty"]}
                              placeholder="Warranty in Days"
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="mt-1.5">
                      <Button size="small" type="primary" block loading={!!miscLoading[record?.query_id]} onClick={() => handleMiscUpdate(record?.query_id)}>Update</Button>
                    </div>
                  </div>
                </div>


                <Divider style={{ height: "auto" }} type="vertical" />


                <div className="rounded m-3 drop-shadow">
                  <div style={{ backgroundColor: "#f7f7f7" }} className="p-1.5 drop-shadow rounded">
                    <div>
                      <div className="pl-1" style={{ fontSize: "10px", fontWeight: "540" }}>
                        Quick Actions
                      </div>

                      <div className="bg-transparent rounded ">

                        <div style={{ backgroundColor: "#fbfbfb" }} className="border drop-shadow rounded p-1 mt-1">
                          <div>
                            <div style={{ fontSize: "10px" }}>WATI Actions</div>
                            <div>
                              <Dropdown.Button
                                loading={wati_templates_loading}
                                type='primary'
                                size='small'
                                onClick={() => { prepare_wati_messages_loading(record) }}
                                menu={{ items: hover_menu_items, onClick: (e) => onMenuClick(e, record) }}>WATI Templates</Dropdown.Button>
                            </div>
                            <div className="mt-2">
                              <Tooltip title="Under construction">
                                <Button
                                  type="primary"
                                  size='small'
                                  disabled
                                  onClick={() => handleOpenLinkGen(record)}
                                >Schedule Follow-up</Button>
                              </Tooltip>
                            </div>
                          </div>
                        </div>

                        <div style={{ backgroundColor: "#fbfbfb" }} className="border drop-shadow rounded p-1 mt-2.5">
                          <div>
                            <div style={{ fontSize: "10px" }}>Generate Pay-By-Link</div>
                            <Tooltip title="Please use the new WATI Templates Quick Actions Option just above.">
                              <Button
                                type="primary"
                                size='small'
                                onClick={() => handleOpenLinkGen(record)}
                              >Open</Button>
                            </Tooltip>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>


                <Divider style={{ height: "auto" }} type="vertical" />

                <div className="rounded m-3 drop-shadow">

                  <Collapse size='small'
                    className="mt-0"
                    style={{ width: "auto", marginTop: "0.3rem" }}
                    accordion
                    defaultActiveKey={3}
                    items={generateAccordionItems(record)} />

                </div>


              </div>
            ),
          }}
        // rowSelection={rowSelection}
        />
      </div>

      {/*Adding query modal*/}
      <AntdModal
        title={queryModalHeading}
        centered
        loading={false}
        open={open}
        width={1030}
        onCancel={handleClose}
        maskClosable={false}
        footer={<div className="flex justify-between">
          <div id="">
            <Typography>
              Whatsapp Broadcast : {"Not yet"}
            </Typography>
          </div>
          <div>
            <Typography className="flex items-center">
              <div>Suppliers with possible availability :</div>
              &nbsp;{loadApiSuppCount ? (<div className="flex items-end">
                <img src={loading_fountain} style={{ width: "45px" }} /></div>) : (<div className="font-semibold">{suppCount}</div>)}
            </Typography>
          </div>
          <div className="drop-shadow">
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultHoverColor: "#ffffff",
                    defaultColor: "#ffffff",
                    defaultHoverBg: "#3be368",
                    defaultBg: "#31bd56",
                  },
                },
              }}
            >
              <div>
                <Tooltip title={isQsDisabled ? "Please wait till all the images are completely uploaded." : null}>
                  <Button
                    size="middle"
                    id="send_query_btn"
                    disabled={isQsDisabled}
                    onClick={(e) => handleSubmit(false)}
                  >
                    <SaveOutlined />
                    Save
                  </Button>
                </Tooltip>
                <Tooltip title={isQsDisabled ? "Please wait till all the images are completely uploaded." : null}>
                  <Button
                    size="middle"
                    className="ml-2"
                    id="send_query_btn"
                    disabled={isQsDisabled}
                    onClick={(e) => handleSubmit(true)}
                  >
                    <SaveOutlined />
                    Save & Send
                    <SendOutlined />
                  </Button>
                </Tooltip>
              </div>

            </ConfigProvider>

          </div>
        </div >}
      >
        <div>
          <div className="flex justify-between">
            {/* first column*/}
            <div className="border rounded drop-shadow p-3 overflow-y-auto" style={{ height: "390px", width: "560px" }}>
              <div className="border rounded pt-1.5 pb-1 mb-2" >
                <div style={{ fontSize: "11px", marginLeft: "1rem", transform: "translateY(-15px)", marginBottom: "-16px", background: "white", display: "table", borderRadius: "10px", fontWeight: "700" }}>&nbsp;Customer and Source Section&nbsp;</div>
                <Row className="p-1 flex justify-between" style={{ width: "100%" }}>
                  <div style={{ width: "49%" }}>
                    <Space >
                      <Space.Compact >
                        <Select
                          allowClear
                          showSearch
                          filterOption={(input, option) =>
                            option?.label?.toLowerCase()?.indexOf(input?.replace(/^05/, '9715')?.toLowerCase()) >= 0 ||
                            String(option?.value)?.toLowerCase()?.indexOf(input?.replace(/^05/, '9715')?.toLowerCase()) >= 0 ||
                            String(option?.number)?.toLowerCase()?.indexOf(input?.replace(/^05/, '9715')?.toLowerCase()) >= 0
                          }
                          style={{ width: '100%', }}
                          placeholder="Customer Name/Number"
                          value={phone_data}
                          loading={cus_name_loading}
                          options={cus_name_set_for_select}
                          onKeyUp={(e) => reload_customers(e.target.value)}
                          onChange={(e) => handleCusNameChange(e)}
                        />
                        <Tooltip title="If the customer is from some other source than WATI you will have to add them manually.">
                          <Button
                            onClick={() => handleOpenCustomerAddModal()}
                          >+</Button>
                        </Tooltip>
                      </Space.Compact>
                    </Space>

                  </div>
                  <div style={{ width: "49%" }}>
                    <Space>
                      <Space.Compact >
                        <Select
                          allowClear
                          style={{ width: '100%', }}
                          showSearch
                          optionFilterProp="label"
                          placeholder="Query Source"
                          value={queryOrigin || null}
                          onChange={(e) => setQueryOrigin(e)}
                          options={queryOriginSet}
                        />
                        <Button
                          onClick={(e) => handleOpenAddModal("Add New Query source")}
                        >+</Button>
                      </Space.Compact>
                    </Space>
                  </div>
                </Row>
              </div>
              <div className="border rounded pt-1 pb-1 mt-3" >
                <div style={{ fontSize: "11px", marginLeft: "1rem", transform: "translateY(-15px)", marginBottom: "-16px", background: "white", display: "table", borderRadius: "10px", fontWeight: "700" }}>&nbsp;Vehicle Details Section&nbsp;</div>
                <Row className="p-1 flex justify-between" style={{ width: "100%" }}>
                  <div style={{ width: "49%" }}>
                    <Space >
                      <Space.Compact >
                        <AntdInput
                          allowClear
                          style={{ width: '100%', }}
                          placeholder="Chassis Number (VIN)"
                          maxLength={17}
                          value={chassisno_data}
                          onChange={(e) => {
                            set_chassisno_data(e.target.value?.toUpperCase()?.replaceAll(" ", ""))
                          }}
                        />
                        <Button>
                          <div style={{ fontSize: "12px" }} >
                            <SearchIcon fontSize="extra small" />
                          </div>
                        </Button>
                      </Space.Compact>
                    </Space>
                  </div>
                  <div style={{ width: "49%" }}>
                    <Space >
                      <Space.Compact >
                        <Select
                          allowClear
                          showSearch
                          optionFilterProp="label"

                          filterOption={true}
                          placeholder="Select Make"
                          value={brand_data}
                          onChange={(e) => handleBrandChange(e)}
                          options={brandSet}
                        />
                        <Button
                          onClick={(e) => handleOpenAddModal("Add New Make")}
                        >+</Button>
                      </Space.Compact>
                    </Space>
                  </div>
                </Row>
                <Row className="p-1 flex justify-between" style={{ width: "100%" }}>
                  <div style={{ width: "49%" }}>
                    <Space >
                      <Space.Compact >
                        <Select
                          allowClear
                          showSearch
                          optionFilterProp="label"
                          style={{ width: '100%', }}
                          placeholder="Select Model"
                          value={model_data}
                          loading={loading_models}
                          onChange={(e) => { handle_model_change(e); setDefaultActiveKey(1); }}
                          options={modelSet}
                        />
                        <Button
                          onClick={(e) => handleOpenAddModal("Add New Model")}
                        >+</Button>
                      </Space.Compact>
                    </Space>
                  </div>
                  <div style={{ width: "49%" }}>
                    <AntdInput
                      allowClear
                      style={{ width: '100%', }}
                      placeholder="Number of Cylinders"
                      value={cylinder_data}
                      onChange={(e) => {
                        if (/^\d*$/.test(e.target.value)) {
                          set_cylinder_data(e.target.value)
                        }
                      }
                      }
                    />
                  </div>
                </Row>
                <Row className="p-1" style={{ width: "100%" }}>
                  <AntdInput
                    allowClear
                    style={{ width: '100%', }}
                    placeholder="Additional Model Information"
                    value={model_details_data}
                    onChange={(e) => set_model_details_data(e.target.value)}
                  />
                </Row>
                <Row className="p-1 flex justify-between" style={{ width: "100%" }}>
                  <div style={{ width: "49%" }}>
                    <DatePicker
                      style={{ width: '100%', }}
                      maxDate={dayjs(new Date())}
                      placeholder="Select Year of Make"
                      value={year_data ? dayjs(year_data, "YYYY-MM-DD") : null}
                      onChange={(e) => set_year_data(e)}
                      minDate={dayjs("1990-01-01", "YYYY-MM-DD")}
                      picker="year"
                    />
                  </div>
                  <div style={{ width: "49%" }}>
                    <Space >
                      <Space.Compact >
                        <Select
                          allowClear
                          style={{ width: '100%', }}
                          showSearch
                          optionFilterProp="label"
                          placeholder="Select Region"
                          value={region_data}
                          onChange={(e) => handleRegionChange(e)}
                          options={regionDataSet}
                        />
                        <Button
                          onClick={() => handleOpenAddModal("Add New Region")}
                        >+</Button>
                      </Space.Compact>
                    </Space>
                  </div>
                </Row>
                <Row className="p-1">
                  <div className="flex justify-between" style={{ width: "100%" }}>
                    <Space >
                      <Space.Compact >
                        <Select
                          mode="multiple"
                          allowClear
                          style={{ width: '100%', }}
                          optionFilterProp="label"
                          placeholder="Parts"
                          value={bodypart_data}
                          onChange={(e) => set_bodypart_data(e)}
                          options={partsDataSet}
                        />
                        <Button
                          onClick={() => handleOpenAddModal("Add New Part")}
                        >+</Button>
                      </Space.Compact>
                    </Space>
                  </div>
                </Row>
              </div>
              <div className="border rounded pt-1 pb-1 mt-3" >
                <div style={{ fontSize: "11px", marginLeft: "1rem", transform: "translateY(-15px)", marginBottom: "-16px", background: "white", display: "table", borderRadius: "10px", fontWeight: "700" }}>&nbsp;Supplier Group Section&nbsp;</div>
                <Row className="p-1">
                  <Space >
                    <Space.Compact >
                      <Select
                        mode="multiple"
                        allowClear
                        style={{ width: '100%' }}
                        optionFilterProp="label"
                        placeholder="Select Supplier Groups"
                        value={make_data}
                        onChange={(e) => set_make_data(e)}
                        options={makeSet}
                      />
                      <Select
                        className="ml-2 rounded"
                        mode="multiple"
                        allowClear
                        style={{ width: '100%', }}
                        placeholder="Select Supplier Grade"
                        value={supplier_score}
                        onChange={(e) => set_supplier_score(e)}
                        options={supplierScoreDataset}
                      />
                    </Space.Compact>
                  </Space>
                </Row>
              </div>


            </div>
            {/* second divu*/}
            <div>
              <div className="border rounded p-2 drop-shadow">
                <div style={{ fontSize: "11px", transform: "translateY(-16px)", marginBottom: "-16px", background: "white", display: "table", borderRadius: "10px", fontWeight: "700" }}>&nbsp;Additional WATI Actions&nbsp;</div>
                <div className="flex justify-between">
                  <Row className="p-1">
                    <div>
                      <AntdCheckbox
                        checked={followupMsg}
                        onChange={(e) => setFollowupMsg(e.target.checked)}
                        style={{ fontSize: "12px" }}
                      >
                        Set Follow-up Messages
                      </AntdCheckbox>
                    </div>
                  </Row>
                  <Row className="p-1">
                    <div>
                      <AntdCheckbox
                        checked={sendQidToWati}
                        onChange={(e) => setSendQidToWati(e.target.checked)}
                        style={{ fontSize: "12px" }}
                      >
                        Auto-Send QueryID to customer
                      </AntdCheckbox>
                    </div>
                  </Row>
                </div>
              </div>
              <Collapse
                size='small'
                className="mt-1.5 drop-shadow"
                style={{ width: "410px", marginTop: "0.3rem" }}
                accordion
                defaultActiveKey={defaultActiveKey}
                items={[
                  {
                    key: 1,
                    label: `Price History ${priceHistory?.length > 0 ? "(" + priceHistory.length + " Rows found)" : ""}`,
                    children:
                      <div className="border rounded drop-shadow" style={{ backgroundColor: "#ebebeb" }}>
                        <div className="flex p-2.5 mb-1" style={{ height: "230px", width: "100%", scrollSnapType: "y mandatory", scrollBehavior: "smooth" }}>
                          {priceHistory?.length > 0 ? (
                            <div className="rounded overflow-y-auto" style={{ backgroundColor: "white", scrollSnapType: "y mandatory", scrollBehavior: "smooth" }}>
                              {/* <div>
                              Expansion here
                              </div> */}
                              {priceHistory.map((e) => (
                                <div className="rounded m-1.5 mb-2 p-2 " style={{ width: "345px", minHeight: "70px", backgroundColor: "#dedede", borderWidth: "2px" }}>

                                  {/* first row */}
                                  <div className="flex justify-between">
                                    <Tooltip title="Click here to copy the Query ID to the clipboard">
                                      <div className="rounded pl-1 pr-1 cursor-pointer" style={{ backgroundColor: "#636363", color: "white", fontSize: "12px" }} onClick={() => copyToClipboardModern(e.query_id, "Query ID")}>
                                        {e?.query_id || "Unknown"}
                                      </div>
                                    </Tooltip>
                                    <div className="rounded pl-1 pr-1" style={{ backgroundColor: "#636363", color: "white", fontSize: "12px" }}>
                                      {e?.status || "Unknown"}
                                    </div>
                                    <div className="rounded pl-1 pr-1" style={{ backgroundColor: "#636363", color: "white", fontSize: "12px" }}>
                                      {e?.date || "Unknown"}
                                    </div>
                                  </div>

                                  {/* second row */}
                                  <div className="flex justify-center mt-1">
                                    <div className="rounded pl-1 pr-1 flex justify-between" style={{ backgroundColor: "#636363", color: "white", fontSize: "12px", width: "100%" }}>
                                      <div className="flex items-center"><TruckFilled />&nbsp;{e?.Supplier || "Unknown"}</div>
                                      <div>&nbsp;-&nbsp;</div>
                                      <div className="cursor-pointer" onClick={() => copyToClipboardModern(e.SupNo, "Supplier Number")}>
                                        <Tooltip title="Click here to copy the Supplier Phone number to the clipboard">
                                          {e?.SupNo || "Unknown"}
                                        </Tooltip>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Third row */}
                                  <div className="flex justify-center mt-1 border rounded" style={{ backgroundColor: "#f0f0f0" }}>
                                    <table border="1" cellspacing="0" cellpadding="5">
                                      <thead>
                                        <tr>
                                          <th>Parts</th>
                                          <th>BP</th>
                                          <th>SP</th>
                                          <th>Margin</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>{e?.body_part || "Unknown"}</td>
                                          <td>{e?.best_price_received || "Unknown"}</td>
                                          <td>{e?.price_given || "Unknown"}</td>
                                          <td>{e?.margin || "Unknown"}</td>
                                        </tr>
                                      </tbody>
                                    </table>

                                  </div>

                                  {/* Fourth row */}
                                  <div className="flex justify-center mt-1">
                                    <div className="rounded pl-1 pr-1 flex justify-between" style={{ backgroundColor: "#636363", color: "white", fontSize: "12px", width: "100%" }}>
                                      <div><UserOutlined />&nbsp;{e?.cus_name || "Unknown"}</div>
                                      <div>&nbsp;-&nbsp;</div>
                                      <div className="cursor-pointer" onClick={() => copyToClipboardModern(e.phone, "Customer Number")}>
                                        <Tooltip title="Click here to copy the Customer Phone number to the clipboard">
                                          {e?.phone || "Unknown"}
                                        </Tooltip>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex justify-end">
                                    <span className="bold italic" style={{ marginBottom: "-8px", fontSize: "9px" }}>-&nbsp;{e?.name || "Unknown"}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="m-2 p-2 flex justify-center items-center rounded" style={{ width: "100%", backgroundColor: "white" }}>
                              {brand_data && model_data && !loadingPriceHistory
                                ? "No Price History Found"
                                : (<div>
                                  {loadingPriceHistory ? (<div>
                                    <img src={loading_fountain} />
                                  </div>) : (<div><div>Please select make and model to begin search</div>
                                    <div className="flex justify-center" style={{ fontSize: "12px" }}>Add more parameters to refine search</div></div>)}
                                </div>)
                              }
                            </div>
                          )}
                        </div>
                      </div>
                  },
                  {
                    key: 2,
                    label: "Upload Images",
                    children:
                      <div className="border rounded drop-shadow">
                        <div className="overflow-y-auto flex p-2.5" style={{ height: "230px", width: "100%" }}>
                          <Upload
                            action={`${API_DOMAIN}/whatsapp/image_upload`}
                            listType="picture-card"
                            fileList={fileList}
                            beforeUpload={beforeUpload}
                            onPreview={handlePreview}
                            onChange={handleFileChange}
                          >
                            {fileList.length >= 6 ? null : (<button style={{ border: 0, background: 'none', color: 'black' }} type="button" > <PlusOutlined /> <div style={{ marginTop: 8, }} > Upload </div> </button>)}
                          </Upload>
                          {previewImage && (
                            <Image
                              wrapperStyle={{
                                display: 'none',
                              }}
                              preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                              }}
                              src={previewImage}
                            />
                          )}
                        </div>
                      </div>
                  }
                ]}>
              </Collapse>
            </div>
          </div >

        </div >
      </AntdModal >

      {/*Generate Link modal*/}
      <PayByLinkModal openLinkGen={openLinkGen} handleCloseLinkGen={handleCloseLinkGen} linkTitle={linkTitle} setLinkTitleHandler={setLinkTitleHandler} linkDescription={linkDescription} setLinkDescriptionHandler={setLinkDescriptionHandler} linkAmount={linkAmount} setLinkAmount={setLinkAmount} handle_tabby_enable_change={handle_tabby_enable_change} enable_tabby={enable_tabby} pay_by_link_loading={pay_by_link_loading} handleLinkGen={handleLinkGen} linkVATPercent={linkVATPercent} setLinkVATPercent={setLinkVATPercent} disablePercentEdit={disablePercentEdit} linkFeePercent={linkFeePercent} setLinkFeePercent={setLinkFeePercent} theLink={theLink} copyToClipboardModern={copyToClipboardModern} load_send_link_to_wati={load_send_link_to_wati} handleSendWatiLink={handleSendWatiLink} />

      {/*Manage customer address/timings modal*/}
      <AddressManagementModal customerAddressManagementOpen={customerAddressManagementOpen} handleCustomerAddManageClose={handleCustomerAddManageClose} createDeliveryJobLoading={createDeliveryJobLoading} createShipdayDeliveryJob={createShipdayDeliveryJob} setLinkTitleHandler={setLinkTitleHandler} handleCustomerAddressEditOpen={handleCustomerAddressEditOpen} setSelectedDeliveryAddress={setSelectedDeliveryAddress} editSpecificCustomerAddress={editSpecificCustomerAddress} linkTitle={linkTitle} selectedDeliveryAddress={selectedDeliveryAddress} saveAddressLoading={saveAddressLoading} saveCustomerAddress={saveCustomerAddress} selectedDeliveryDriver={selectedDeliveryDriver} setSelectedDeliveryDriver={setSelectedDeliveryDriver}
        deliveryInstruction={deliveryInstruction} setDeliveryInstruction={setDeliveryInstruction} trackingLinkShare={trackingLinkShare} setTrackingLinkShare={setTrackingLinkShare}
        expectedDeliveryDate={expectedDeliveryDate} setExpectedDeliveryDate={setExpectedDeliveryDate} expectedDeliveryTime={expectedDeliveryTime} setExpectedDeliveryTime={setExpectedDeliveryTime} />

      {/*Add customer address/timings modal*/}
      <AddEditAddresses editCustomerAddress={editCustomerAddress} handleCustomerAddressEditClose={handleCustomerAddressEditClose} saveAddressLoading={saveAddressLoading} saveCustomerAddress={saveCustomerAddress} setEditCustomerAddress={setEditCustomerAddress} />

      {/*make, modal, region etc adding modal*/}
      < AntdModal
        title={modalHeading}
        open={open_add_modal}
        onCancel={handleCloseAddModal}
        width={400}
        centered
        footer={
          < div className="flex justify-end" >
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultHoverColor: "#ffffff",
                    defaultHoverBg: "#3be368",
                    defaultBg: "#31bd56",
                  },
                },
              }}
            >
              <Button
                loading={adding_modal_loading}
                size="middle"
                onClick={(e) => handleModalAdd(e, modalHeading)}
              >
                <SaveOutlined />
                Save
              </Button>
            </ConfigProvider>
          </div >
        }
      >
        <div className="rounded border p-2 m-2 drop-shadow">
          <div style={{ color: "gray", fontSize: "12px" }} className="flex justify-center mb-2 p-1">
            <i>
              Try to avoid spelling mistakes and keep the text formatting (capitalization of letters) correct.
            </i>
          </div>
          <AntdInput
            className="mb-2"
            allowClear
            size="large"
            placeholder="Enter the value"
            value={modal_data}
            onChange={(e) => set_modal_data(e.target.value)}
          />
        </div>
      </AntdModal >

      {/*Modal to edit settings*/}
      < SettingsModal
        open_settings={open_settings}
        handleCloseSettingsModal={handleCloseSettingsModal}
        statuses={queryStatusSet}
        save={save_settings}
      />

      {/*wati message approval modal*/}
      < AntdModal
        title={"Review Price Qoutes before approving and sending to"}
        centered
        open={wati_msgs_waiting_approval_modal}
        onCancel={handleCloseWatiApproval}
        maskClosable={false}
        loading={false}
        width={1400}
        footer={
          <div className="flex justify-start italic" style={{
            fontSize: "12px"
          }}>
            * All pending qoutes are always on the top of the list.
          </div >}
      >
        <div className="border rounded m-2 p-3 drop-shadow" style={{ maxHeight: "500px", overflowY: "auto" }}>
          <Table
            rowKey={(record) => record.id}
            dataSource={wati_msgs_waiting_approval}
            className="drop-shadow border rounded"
            style={{ width: "100%", minWidth: "70%", overflowX: "auto", backgroundColor: "unset !important" }}
            columns={columns_wati_approval_table}
            // loading={loading_wati_approval_table}
            bordered={true}
            pagination={{
              position: ["topRight", "bottomRight"],
            }}
          />

        </div>
      </AntdModal >

      {/* wati bulk messages sending modal */}
      <SendRemindertoWati
        useSnackbar={useSnackbar}
        watiBulkMessageCombo={watiBulkMessageCombo}
        handleWatiBulkMessageComboClose={handleWatiBulkMessageComboClose}
        selectedRowKeys={selectedRowKeys}
        onFollowupChange={onFollowupChange}
        followupChoice={followupChoice}
        send_wati_bulk_messages={send_wati_bulk_messages}
        sendLoadingWatiBulk={sendLoadingWatiBulk}
        rowSelection={rowSelection}
        formatDuration={formatDuration}
        get_price_given_time={get_price_given_time}
        copyToClipboardModern={copyToClipboardModern}
        carLogoTypes={carLogoTypes}
        open_wati_chat={open_wati_chat}
        followup_id={followup_id}
        onFollowupIdChange={onFollowupIdChange}
      />

      {/* wati templates showing main modal */}
      <WatiTemplatesModal allTemplateData={allTemplateData} setAllTemplateData={setAllTemplateData} />

      {/* wati message final modal to show message before sending message */}
      <WatiFinalViewModal allTemplateData={allTemplateData} setAllTemplateData={setAllTemplateData} handlCloseWatiFinalView={handlCloseWatiFinalView} open_wati_chat={open_wati_chat} supplierSet={supplierSet} send_wati_general_message={process_and_schedule_wati_general_message} priceValues={priceValues} handleBestPriceChange={handleBestPriceChange} handlePercentageChange={handlePercentageChange} handleDeliverycostChange={handleDeliverycostChange} handleGivenPriceChange={handleGivenPriceChange} handlePriceUpdate={handleSupplierPriceUpdate} handleQueryUpdate={handleQueryUpdate} setquerySet={setquerySet} setquerySetTable={setquerySetTable} handleWarrantyChange={handleWarrantyChange} handleWarrantyUpdate={handleMiscUpdate} approval_message_view={approval_message_view} send_wati_approved_message={send_wati_approved_message} carLogoTypes={carLogoTypes} />

      <CustomerAddModal openCustomerAddModal={openCustomerAddModal}
        handleCloseCustomerAddModal={handleCloseCustomerAddModal} cus_name_set_for_select={cus_name_set_for_select}
        set_cus_name_set_for_select={set_cus_name_set_for_select} reload_customers={reload_customers} set_phone_data={set_phone_data}
        useSnackbar={useSnackbar}
      />

      <ToastContainer />
    </>
  );
}

export default Queryset;
